import {css} from "linaria";

export const articleList = css`
  hr {
    line-height: 0
  }

  .lk .basic-width {
    width: auto;
    margin: 0;
    padding: 0
  }

  @media print {
    .standard-block-settings {
      margin: 0 !important;
      padding: 0 !important
    }
  }

  .list-paginator .items-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex
  }

  .select2-container--open {
    z-index: 1000
  }

  article, figure, section {
    display: block
  }

  video {
    display: inline-block;
    vertical-align: baseline
  }

  strong {
    font-weight: 600
  }

  h1 {
    font-size: 2em;
    margin: .67em 0
  }

  figure {
    margin: 1em 40px
  }

  hr {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 0
  }

  select {
    color: inherit;
    font: inherit;
    margin: 0;
    text-transform: none
  }

  input[type=checkbox] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0
  }

  table {
    border-collapse: collapse;
    border-spacing: 0
  }

  td {
    padding: 0
  }

  @media print {
    tr {
      page-break-inside: avoid
    }

    h2, h3 {
      orphans: 3;
      widows: 3;
      page-break-after: avoid
    }

    .table {
      border-collapse: collapse !important
    }

    .table td {
      background-color: #fff !important
    }
  }

  select {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit
  }

  figure {
    margin: 0
  }

  hr {
    margin-top: 19px;
    margin-bottom: 19px;
    border: 0;
    border-top: 1px solid #ababab
  }

  .h1, .h2, .h3, h1, h2, h3 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit
  }

  .h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small {
    font-weight: 300;
    line-height: 1;
    color: #9c9b9b
  }

  .h1, .h2, .h3, h1, h2, h3 {
    margin-top: 19px;
    margin-bottom: 9.5px
  }

  .h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small {
    font-size: 65%
  }

  .h1, h1 {
    font-size: 36px
  }

  .h2, h2 {
    font-size: 30px
  }

  .h3, h3 {
    font-size: 24px
  }

  ol {
    margin-top: 0;
    margin-bottom: 9.5px
  }

  ol ol, ol ul, ul ol {
    margin-bottom: 0
  }

  address {
    margin-bottom: 19px;
    line-height: 1.398
  }

  .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-6, .col-xs-9, .col-xs-10, .col-xs-12 {
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    float: left
  }

  .col-xs-12 {
    width: 100%
  }

  .col-xs-10 {
    width: 83.3333%
  }

  .col-xs-9 {
    width: 75%
  }

  .col-xs-6 {
    width: 50%
  }

  .col-xs-4 {
    width: 33.3333%
  }

  .col-xs-3 {
    width: 25%
  }

  .col-xs-2 {
    width: 16.6667%
  }

  h1 {
    -webkit-transition: width 1s ease-out;
    transition: width 1s ease-out
  }

  input[type=checkbox] {
    margin: 4px 0 0;
    margin-top: 1px \\9;
    line-height: normal
  }

  input[type=checkbox]:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px
  }

  .checkbox {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px
  }

  .checkbox label {
    min-height: 19px;
    padding-left: 20px;
    margin-bottom: 0;
    font-weight: 400;
    cursor: pointer
  }

  .checkbox input[type=checkbox] {
    position: absolute;
    margin-left: -20px;
    margin-top: 4px \\9
  }

  .checkbox + .checkbox {
    margin-top: -5px
  }

  .green-button.active:focus, .green-button:active:hover {
    color: #fff;
    background-color: #3f8f38
  }

  .yellow-button {
    color: #000;
    background-color: #eede2a;
    border-color: #f2e559
  }

  .yellow-button.active, .yellow-button:active, .yellow-button:focus, .yellow-button:hover {
    color: #000;
    background-color: #d4c411
  }

  .yellow-button.active:focus, .yellow-button.active:hover, .yellow-button:active:focus, .yellow-button:active:hover {
    color: #000;
    background-color: #b3a60e
  }

  .yellow-button.active, .yellow-button:active {
    background-image: none
  }

  tr.collapse.in {
    display: table-row
  }

  tbody.collapse.in {
    display: table-row-group
  }

  .close {
    float: right;
    font-size: 21px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .2;
    filter: alpha(opacity=20)
  }

  .close:focus, .close:hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: .5;
    filter: alpha(opacity=50)
  }

  button.close {
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    -webkit-appearance: none
  }

  .footer .footer-row:after, .page-title:after, .page-title:before, .title-panel-inner:after, .title-panel-inner:before {
    content: " ";
    display: table
  }

  .page-title:after, .title-panel-inner:after {
    clear: both
  }

  @media (max-width: 767px) {
    table.visible-xs {
      display: table !important
    }

    tr.visible-xs {
      display: table-row !important
    }

    td.visible-xs {
      display: table-cell !important
    }
  }

  table {
    background-color: transparent
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 19px
  }

  .table > tbody > tr > td {
    padding: 8px;
    line-height: 1.398;
    vertical-align: top;
    border-top: 1px solid #ddd
  }

  .table > tbody + tbody {
    border-top: 2px solid #ddd
  }

  .table .table {
    background-color: #fafafa
  }

  table td[class*=col-] {
    position: static;
    float: none;
    display: table-cell
  }

  .table > tbody > tr.active > td, .table > tbody > tr > td.active {
    background-color: #f5f5f5
  }

  .table > tbody > tr.success > td, .table > tbody > tr > td.success {
    background-color: #dff0d8
  }

  .table > tbody > tr.warning > td, .table > tbody > tr > td.warning {
    background-color: #fcf8e3
  }

  input[type=color], input[type=time], select {
    border: 1px solid #ddd;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    display: block;
    position: relative;
    width: 100%;
    margin: 0 0 15px;
    vertical-align: top;
    outline: 0;
    zoom: 1;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    background-color: #fff;
    color: #333;
    height: 38px;
    padding: 5px 15px;
    font-size: 13px
  }

  input[type=color]:active, input[type=color]:focus, input[type=time]:active, input[type=time]:focus, select:active, select:focus {
    background-color: #fff;
    border-color: #66c05d;
    color: #333
  }

  input:not([type]) ::-webkit-input-placeholder, input[type=color] ::-webkit-input-placeholder, input[type=email] ::-webkit-input-placeholder, input[type=text] ::-webkit-input-placeholder, input[type=time] ::-webkit-input-placeholder, input[type=url] ::-webkit-input-placeholder, select ::-webkit-input-placeholder {
    color: #999
  }

  input:not([type]) :-moz-placeholder, input:not([type]) ::-moz-placeholder, input[type=color] :-moz-placeholder, input[type=color] ::-moz-placeholder, input[type=email] :-moz-placeholder, input[type=email] ::-moz-placeholder, input[type=text] :-moz-placeholder, input[type=text] ::-moz-placeholder, input[type=time] :-moz-placeholder, input[type=time] ::-moz-placeholder, input[type=url] :-moz-placeholder, input[type=url] ::-moz-placeholder, select :-moz-placeholder, select ::-moz-placeholder {
    color: #999
  }

  input:not([type]) :-ms-input-placeholder, input[type=color] :-ms-input-placeholder, input[type=email] :-ms-input-placeholder, input[type=text] :-ms-input-placeholder, input[type=time] :-ms-input-placeholder, input[type=url] :-ms-input-placeholder, select :-ms-input-placeholder {
    color: #999
  }

  .page-title {
    font-weight: 600;
    text-transform: uppercase;
    position: relative;
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 0;
    padding-right: 0
  }

  @media (min-width: 768px) {
    .page-title {
      padding-top: 30px;
      padding-bottom: 5px;
      font-size: 36px
    }
  }

  @media (max-width: 767px) {
    .page-title {
      padding-top: 20px;
      padding-bottom: 15px;
      font-size: 18px
    }
  }

  .custom-checkbox .custom-checkbox-inner {
    background-size: cover;
    cursor: pointer
  }

  .custom-checkbox .custom-checkbox-label {
    cursor: pointer;
    position: relative;
    font-weight: 300;
    line-height: 16px;
    padding-left: 20px;
    padding-right: 10px
  }

  .custom-checkbox .custom-checkbox-label:before {
    background: #fff;
    border: 1px solid #ddd;
    position: absolute;
    left: 0;
    width: 15px;
    height: 15px;
    content: " "
  }

  .custom-checkbox .custom-checkbox-label:after {
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: transparent;
    background-position: 0 0;
    background-repeat: no-repeat;
    top: 3px;
    left: 2px;
    width: 11px;
    height: 9px;
    opacity: 0;
    content: " ";
    position: absolute
  }

  .custom-checkbox input[type=checkbox] {
    display: none
  }

  .custom-checkbox input[type=checkbox].checked ~ .custom-checkbox-label:before, .custom-checkbox input[type=checkbox]:checked ~ .custom-checkbox-label:before {
    border-color: #66c05d
  }

  .custom-checkbox input[type=checkbox].checked ~ .custom-checkbox-label:after, .custom-checkbox input[type=checkbox]:checked ~ .custom-checkbox-label:after {
    font-family: Leroy Merlin Icons, serif;
    opacity: 1;
    color: #66c05d;
    content: "\\E924";
    font-size: 10px;
    top: 1px;
    left: 2px
  }

  .list-paginator {
    font-weight: 600
  }

  .list-paginator .item-wrapper {
    display: inline-block
  }

  .list-paginator .paginator-item {
    color: #000;
    font-size: 16px;
    padding: 4px 5px;
    margin: 0 4px;
    cursor: pointer;
  }

  .list-paginator .paginator-item:focus, .list-paginator .paginator-item:hover {
    text-decoration: none;
    color: #66c05d
  }

  .list-paginator .paginator-item.active {
    background-color: #66c05d;
    color: #fff
  }

  .list-paginator .delimiter:hover {
    color: #000
  }

  .list-paginator .items-wrapper, .list-paginator .next-paginator-button-wrapper, .list-paginator .prev-paginator-button-wrapper {
    display: inline-block;
    vertical-align: bottom
  }

  .list-paginator .paginator-button {
    background-color: transparent;
    width: 23px;
    height: 25px;
    display: block;
    position: relative;
    text-decoration: none
  }

  .list-paginator .paginator-button:after {
    top: 50%;
    width: 0;
    height: 0;
    margin-top: -5px;
    display: block;
    content: "";
    text-indent: -9999px;
    pointer-events: none;
    position: absolute;
    border: 5px solid rgba(102, 192, 93, 0);
    -webkit-transition: all .2s ease;
    transition: all .2s ease
  }

  .list-paginator .prev-paginator-button {
    border-right: 1px solid #e0e0e0
  }

  .list-paginator .prev-paginator-button:after {
    left: -2px;
    border-right-color: #66c05d
  }

  .list-paginator .next-paginator-button {
    border-left: 1px solid #e0e0e0
  }

  .list-paginator .next-paginator-button:after {
    left: 12px;
    border-left-color: #66c05d
  }

  .basic-width {
    width: 1200px;
    margin: 0 auto;
    padding: 0 10px
  }

  h2.page-title {
    margin: 0;
    font-size: 36px;
    font-weight: 600;
    color: #000
  }

  .page-title, .title-panel-inner {
    margin-left: -10px;
    margin-right: -10px
  }

  .page-title:after, .page-title:before {
    content: " ";
    display: table
  }

  .page-title:after {
    clear: both
  }

  .page-title .page-title-inner {
    position: relative;
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 3px 0 auto;
    font-weight: 600;
    display: inline;
    padding-bottom: 10px
  }

  @media (min-width: 768px) {
    .page-title .page-title-inner {
      font-size: 36px
    }
  }

  @media (max-width: 767px) {
    .page-title .page-title-inner {
      font-size: 18px
    }
  }

  .icon-print {
    font-size: 13px;
    vertical-align: sub;
    padding-right: 10px
  }

  .icon-print:before {
    content: "\\E928"
  }

  .icon-dwnl {
    font-size: 13px;
    vertical-align: sub;
    padding-right: 10px
  }

  .icon-dwnl:before {
    content: "\\F019"
  }

  .ui-tooltip.right {
    border-radius: 1px 1px 0
  }

  .ui-tooltip {
    background: rgba(74, 74, 74, .8) !important;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 1px 1px 1px 0;
    max-width: 250px;
    color: #fff !important;
    line-height: 1.1;
    text-align: left;
    z-index: 9000;
    font-size: 11px
  }

  .header-block .header-inner.is-sticky {
    -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, .4);
    box-shadow: 0 0 2px rgba(0, 0, 0, .4);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1020
  }

  @media (max-width: 767px) {
    .header-block .header-inner.is-sticky {
      -webkit-box-shadow: none;
      box-shadow: none
    }
  }

  .header-block .header-inner.is-sticky .logo-icon img {
    height: 55px
  }

  @media (min-width: 767px) {
    .header-block .header-inner.is-sticky .logo-icon img {
      margin-top: 10px
    }
  }

  .header-block .header-inner.is-sticky .catalog-menu {
    margin-top: 8px
  }

  .header-block .header-inner.is-sticky .card-quick {
    margin-top: 0
  }

  .header-block .header-inner .header-row .shop-list-and-basket-block .card-quick .basket-link .basket-sum .item-price-int {
    font-size: 13px
  }

  .header-block .header-inner .header-row .shop-list-and-basket-block .card-quick .basket-link .basket-sum .item-price-fractional {
    font-size: 10px
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-scroll.scroll {
    position: relative;
    overflow: hidden
  }

  .shop-list-wrapper .shop-list-not-empty .card-item {
    background: #fff;
    position: relative;
    clear: both;
    display: table;
    vertical-align: top;
    padding: 15px 0;
    border-top: 1px solid #ddd
  }

  .shop-list-wrapper .shop-list-not-empty .card-item:first-child {
    border-top: 0
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc {
    position: relative;
    overflow: hidden;
    display: table-cell;
    vertical-align: top;
    width: 150px;
    padding-right: 10px;
    word-break: break-all
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc .card-item-article {
    margin-bottom: 0;
    font-size: 10px;
    line-height: 1.6;
    text-align: left;
    color: #999
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc .card-item-article .characteristic {
    font-weight: 700
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc .card-item-name {
    margin-bottom: 5px;
    font-size: 11px;
    font-weight: 400;
    text-align: left;
    max-width: 125px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc .card-item-name a {
    border-color: transparent;
    color: #333
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-desc .card-item-name a:hover {
    color: #66c05d
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-picture {
    margin-right: 15px;
    border: 1px solid #ddd;
    width: 60px;
    height: 60px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-picture .product-image {
    width: 58px;
    height: 58px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total {
    width: 135px;
    margin-left: 20px;
    height: 64px;
    display: table-cell;
    vertical-align: top
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum {
    position: relative;
    overflow: hidden
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price {
    font-weight: 700;
    line-height: 1.1;
    text-align: left;
    margin-bottom: 15px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price .price-int {
    font-size: 14px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price .price-separator {
    font-weight: 700;
    font-size: 13px;
    margin-left: -3px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price .price-fractional {
    font-size: 12px;
    margin-left: -3px
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price .currency {
    font-size: 13px;
    font-weight: 400
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .card-item-total .card-item-sum .card-item-sum-price .unit {
    font-weight: 400
  }

  .shop-list-wrapper .shop-list-not-empty .card-item .icon-delete {
    position: absolute;
    width: 22px;
    top: 15px;
    right: 0;
    left: auto;
    cursor: pointer;
    z-index: 1
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total {
    border-top: 2px solid #ddd;
    clear: both;
    text-align: left;
    padding-top: 15px
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .shopping-list-link {
    width: 82.9404%;
    margin: 15px 2.3577% 0 8.5298%
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .shopping-list-link:hover {
    background-color: #4ba842;
    border-color: #4ba842
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .shopping-list-link:active {
    background-color: #43963a;
    border-color: #43963a
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .card-quick-total-qt {
    font-size: 12px;
    text-transform: uppercase
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .card-quick-total-qt .products-count {
    font-size: 16px;
    font-weight: 700
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .card-quick-total-sum {
    float: right;
    font-size: 12px;
    white-space: nowrap;
    text-transform: uppercase
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .card-quick-total-sum .currency {
    font-size: 11px;
    text-transform: none
  }

  .shop-list-wrapper .shop-list-not-empty .card-quick-total .card-quick-total-sum .fractional-currency {
    font-weight: 700;
    font-size: 16px;
    text-transform: none
  }

  .shop-list-wrapper .shop-list-not-empty .mCSB_container {
    width: 348px
  }

  .shop-list-wrapper .shop-list-not-empty .mCSB_dragger_bar {
    width: 3px;
    margin-left: 13px
  }

  .shop-list-wrapper .shop-list-not-empty .mCSB_draggerRail {
    width: 3px;
    margin-left: 13px;
    background-color: #ddd
  }

  .spinner-ajax h1 {
    font-size: 28px;
    font-weight: 700
  }

  .product-quick-view h1 {
    margin-top: 0;
    color: #333;
    font-weight: 600;
    font-size: 28px
  }

  .leftmenu-small {
    width: 100%;
    background-color: transparent
  }

  .leftmenu-small .name {
    font-size: 28px;
    margin: 29px 0;
    color: #333;
    font-weight: 600;
    line-height: 1.1;
    text-transform: none
  }

  .leftmenu-small ul {
    background-color: #fff;
    padding: 0
  }

  .leftmenu-small ul, .leftmenu-small ul li {
    width: 100%;
    margin: 0;
    position: relative;
    display: block
  }

  .leftmenu-small ul li {
    padding: 5px 0;
    list-style-type: none;
    border-bottom: 1px solid #eee
  }

  .leftmenu-small ul li span {
    height: 15px;
    display: block;
    width: 31px;
    text-align: center;
    background: #f0f0f0;
    border-radius: 2px;
    font-size: 11px;
    line-height: 16px;
    color: #727272;
    padding-left: 3px;
    padding-right: 3px;
    position: absolute;
    right: 8px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
  }

  .leftmenu-small ul li.banner a {
    padding: 4px 0
  }

  .leftmenu-small ul li.banner a img {
    max-width: 100%
  }

  .leftmenu-small ul li .cat, .leftmenu-small ul li .type, .leftmenu-small ul li a {
    width: 100%;
    padding: 4px 46px 4px 20px;
    font-size: 12px;
    line-height: 22px;
    position: relative;
    color: #727272;
    text-decoration: none;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    cursor: pointer;
    display: block
  }

  .leftmenu-small ul li.active, .leftmenu-small ul li:hover, .leftmenu-small ul li:hover .cat, .leftmenu-small ul li:hover .type {
    color: #fff;
    background: #66c05d
  }

  .leftmenu-small ul li.active a, .leftmenu-small ul li:hover .cat a, .leftmenu-small ul li:hover .type a, .leftmenu-small ul li:hover a {
    color: #fff
  }

  .leftmenu-small ul li.active span, .leftmenu-small ul li:hover .cat span, .leftmenu-small ul li:hover .type span, .leftmenu-small ul li:hover span {
    color: #66c05d
  }

  .basket-wrapper .basket-not-empty .card-quick-total .card-quick-total-sum .fractional-currency .item-price-fractional {
    font-size: 12px
  }

  .compare-panel.is_active {
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
  }

  .ui-tooltip {
    padding: 8px;
    position: absolute;
    z-index: 9999;
    max-width: 300px
  }

  body .ui-tooltip {
    border-width: 2px
  }

  .ui-widget, .ui-widget .ui-widget, .ui-widget button, .ui-widget input, .ui-widget select {
    font-size: 1em
  }

  .ui-widget.ui-widget-content {
    border: 1px solid #c5c5c5
  }

  .ui-widget-content {
    border: 1px solid #ddd;
    background: #fff;
    color: #333
  }

  .ui-widget-content a {
    color: #333
  }

  .ui-corner-all {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px
  }

  .ui-widget-shadow {
    -webkit-box-shadow: 0 0 5px #666;
    box-shadow: 0 0 5px #666
  }

  .select2-container {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    margin: 0;
    position: relative;
    vertical-align: middle
  }

  .select2-container .select2-selection--single {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    display: block;
    height: 38px;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    background: transparent -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(50%, #f8f8f8)) repeat scroll 0 0;
    background: transparent linear-gradient(180deg, #fff, #f8f8f8 50%) repeat scroll 0 0;
    border-radius: 2px;
    -webkit-box-shadow: none;
    box-shadow: none
  }

  .select2-container .select2-selection--single .select2-selection__rendered {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 38px;
    padding-left: 15px;
    padding-right: 36px;
    height: 38px
  }

  .select2-container.select2-container--focus .select2-selection--single, .select2-container.select2-container--open .select2-selection--single {
    border: 1px solid #66c05d;
    -webkit-box-shadow: none;
    box-shadow: none
  }

  .select2-container .select2-results__option--highlighted[aria-selected] {
    background: #66c05d none repeat scroll 0 0;
    color: #fff
  }

  .select2-container--default .select2-results > .select2-results__options, .select2-selection:focus {
    border-color: #4ba842;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: 0 none
  }

  .select2-results__option {
    padding: 4px 15px;
    line-height: 19px
  }

  .select2-container .select2-search .select2-search__field {
    margin-bottom: 0
  }

  .select2-dropdown {
    background-color: #fff;
    border: 1px solid #66c05d;
    border-radius: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    position: absolute;
    left: -100000px;
    width: 100%;
    z-index: 1051
  }

  .select2-results {
    display: block
  }

  .select2-results__options {
    list-style: none;
    margin: 0;
    padding: 0
  }

  .select2-results__option {
    padding: 6px;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none
  }

  .select2-results__option[aria-selected] {
    cursor: pointer
  }

  .select2-container--open .select2-dropdown {
    left: 0
  }

  .select2-container--open .select2-dropdown--below {
    border-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0
  }

  .select2-search--dropdown {
    display: block;
    padding: 4px
  }

  .select2-search--dropdown .select2-search__field {
    padding: 4px;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
  }

  .select2-search--dropdown .select2-search__field::-webkit-search-cancel-button {
    -webkit-appearance: none
  }

  .select2-search--dropdown.select2-search--hide {
    display: none
  }

  .select2-hidden-accessible {
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important
  }

  .select2-container--default .select2-selection--single {
    -webkit-box-shadow: inset 0 2px 3px 1px #fff;
    box-shadow: inset 0 2px 3px 1px #fff;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px
  }

  .select2-container--default .select2-selection--single .select2-selection__rendered {
    color: #444;
    line-height: 35px
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 36px;
    width: 36px;
    position: absolute;
    top: 1px;
    right: 1px
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow b {
    left: 50%;
    margin-left: -4px;
    position: absolute;
    top: 50%;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgOCAxNiI+IDxkZWZzPiA8c3R5bGU+IC5jbHMtMSB7IGZpbGwtcnVsZTogZXZlbm9kZDsgfSA8L3N0eWxlPiA8L2RlZnM+IDxwYXRoIGNsYXNzPSJjbHMtMSIgZmlsbD0iIzMzMyIgZD0iTTgsNSw4LDVMNCwwLDAsNUg4bTAsNiwwLDBMNCwxNiwwLDExSDgiLz48L3N2Zz4=);
    background-position: 0 0;
    background-repeat: no-repeat;
    border: 0;
    width: 8px;
    height: 16px;
    margin-top: -8px
  }

  .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
    border-color: transparent transparent #888;
    border-width: 0 4px 5px
  }

  .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
  }

  .select2-container--default .select2-search--dropdown .select2-search__field {
    border: 1px solid #aaa
  }

  .select2-container--default .select2-results > .select2-results__options {
    max-height: 200px;
    overflow-y: auto
  }

  .select2-container--default .select2-results__option[aria-selected=true] {
    background-color: #ddd
  }

  .select2-container--default .select2-results__option .select2-results__option {
    padding-left: 1em
  }

  .select2-container--default .select2-results__option .select2-results__option .select2-results__option {
    margin-left: -1em;
    padding-left: 2em
  }

  .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option {
    margin-left: -2em;
    padding-left: 3em
  }

  .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {
    margin-left: -3em;
    padding-left: 4em
  }

  .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {
    margin-left: -4em;
    padding-left: 5em
  }

  .select2-container--default .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option {
    margin-left: -5em;
    padding-left: 6em
  }

  .select2-container--default .select2-results__option--highlighted[aria-selected] {
    background: #66c05d none repeat scroll 0 0;
    color: #fff
  }

  .category-description {
    width: 100%;
    padding: 30px;
    margin: 30px 0;
    background-color: #fff
  }

  .category-description .layout {
    height: auto
  }

  .category-description .layout .text {
    color: #666;
    font-size: 12px;
    line-height: 20px
  }

  .category-description .layout .text p {
    margin: 0 0 9px
  }

  .category-description .layout .text li {
    margin-bottom: 1px
  }

  .category-description .layout .text ol, .category-description .layout .text ul {
    margin-bottom: 12px
  }

  .category-description .layout .text ul {
    margin-left: 45px;
    padding: 0
  }

  .category-description .layout .text li, .category-description .layout .text ul {
    list-style-position: outside
  }

  .category-description .layout .text h1:first-child, .category-description .layout .text h2:first-child, .category-description .layout .text h3:first-child, .category-description .layout .text h4:first-child {
    margin-top: 0
  }

  .category-description .layout .text h1, .category-description .layout .text h2 {
    margin: 6px 0 8px;
    font-size: 16px;
    line-height: 21px
  }

  .category-description .layout .text h3, .category-description .layout .text h4 {
    margin: 16px 0 8px;
    font-size: 14px;
    line-height: 20px
  }

  .category-description .layout .text a {
    text-decoration: underline;
    color: #66c05d
  }

  .category-description .layout .text a:hover {
    text-decoration: underline;
    color: #4ba842
  }

  .brands h1 {
    color: #333;
    text-transform: none;
    font-size: 24px;
    font-weight: 600;
    margin: 30px 15px 30px 10px
  }

  .section:after, .section:before {
    content: " ";
    display: table
  }

  .section:after {
    clear: both
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .next-paginator-button-wrapper, .prev-paginator-button-wrapper {
      display: none !important
    }
  }

  .dots-item {
    padding: 0 !important;
    margin: 0 !important
  }

  .faq h1 {
    padding-top: 0;
    margin: 30px 0;
    font-size: 36px;
    color: #333;
    text-transform: uppercase;
    font-weight: 600
  }

  .howto-filters {
    background-color: transparent;
    font-size: 11px;
    letter-spacing: normal;
    margin-bottom: 13px
  }

  .howto-filters .custom-checkbox {
    padding-top: 45px
  }

  .howto-filters .custom-checkbox .custom-checkbox-inner {
    display: inline-block;
    padding-right: 10px
  }

  .howto-filters .custom-checkbox label {
    font-size: 12px
  }

  .howto-filters .custom-checkbox strong {
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 8px
  }

  .howto-filters .custom-checkbox .link {
    font-size: 12px;
    color: #66c05d;
    text-decoration: none;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    border-bottom: 1px dotted #66c05d;
    margin-left: 10px
  }

  .howto-filters .custom-checkbox .link:hover {
    border-bottom: 0;
    color: #4ba842
  }

  .howto-filters .custom-checkbox .grey {
    color: #999
  }

  .howto-filters .howto-sorting {
    padding: 35px 0 0;
    min-height: 1px;
    font-size: 12px;
    float: right;
    width: 223px
  }

  .howto-filters .howto-sorting .howto-sorting-inner {
    text-align: left
  }

  .howto-filters .howto-sorting .howto-sorting-inner label {
    font-size: 9px;
    color: #999;
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 8px;
    padding-top: 15px
  }

  .howto-filters .howto-sorting .howto-sorting-inner select {
    width: 140px;
    display: inline-block;
    border-radius: 2px;
    -webkit-box-shadow: none;
    box-shadow: none;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(50%, #f8f8f8));
    background: linear-gradient(180deg, #fff, #f8f8f8 50%)
  }

  .article, .article section, .howto, .howto section {
    margin-left: auto;
    margin-right: auto
  }

  .article section, .howto section {
    width: 1150px
  }

  .article .left-block, .howto .left-block {
    padding-left: 0
  }

  .article h1, .howto h1 {
    margin-top: 0;
    font-size: 29px;
    color: #333;
    text-transform: uppercase;
    font-weight: 600
  }

  .article h2, .howto h2 {
    text-transform: uppercase;
    font-weight: 600;
    margin: 20px 0;
    font-size: 20px
  }

  .article .howto-content, .howto .howto-content {
    background-color: #fff;
    margin-bottom: 20px;
    padding: 0;
    font-size: 14px;
    height: auto
  }

  .article .howto-content .main-img, .howto .howto-content .main-img {
    max-height: 100%;
    position: relative;
    width: 100%;
    margin-bottom: 30px
  }

  .article .howto-content .main-img img, .howto .howto-content .main-img img {
    width: 100%
  }

  .article .howto-content .main-img .howto-label, .howto .howto-content .main-img .howto-label {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: auto;
    font-weight: 400
  }

  .article .howto-content .btns, .howto .howto-content .btns {
    position: absolute;
    bottom: 8px;
    right: 11px;
    z-index: 2
  }

  .article .howto-content .btns .download-button, .howto .howto-content .btns .download-button {
    margin-left: 10px
  }

  .article .howto-content .bottom-block, .howto .howto-content .bottom-block {
    min-height: 80px;
    position: relative;
    margin-top: 20px;
    padding: 20px;
    border-top: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1
  }

  .article .howto-content .bottom-block .btns, .howto .howto-content .bottom-block .btns {
    bottom: 20px
  }

  .article .howto-content .bottom-block .social, .howto .howto-content .bottom-block .social {
    position: relative;
    clear: both;
    margin: 0;
    padding: 0
  }

  .article .howto-content .bottom-block .social .social-title, .howto .howto-content .bottom-block .social .social-title {
    line-height: 35px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 18px;
    display: inline-block
  }

  .article .howto-content .bottom-block .social .social-panel, .howto .howto-content .bottom-block .social .social-panel {
    display: inline-block;
    vertical-align: top;
    padding: 0;
    margin: 0;
    list-style-type: none
  }

  .article .howto-content .bottom-block .social .social-panel li, .howto .howto-content .bottom-block .social .social-panel li {
    display: inline-block;
    position: relative;
    background-color: #d3d3d3;
    height: 35px;
    width: 35px;
    border-radius: 2px
  }

  .article .howto-content .bottom-block .social .social-panel li span, .howto .howto-content .bottom-block .social .social-panel li span {
    height: 35px;
    width: 35px
  }

  .article .howto-content .bottom-block .social .social-panel li + li, .howto .howto-content .bottom-block .social .social-panel li + li {
    margin-left: 10px
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_facebook .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_facebook .ya-share2__badge {
    background-color: #3b5998 !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_vkontakte .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_vkontakte .ya-share2__badge {
    background-color: #48729e !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_twitter .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_twitter .ya-share2__badge {
    background-color: #00aced !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_odnoklassniki .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_odnoklassniki .ya-share2__badge {
    background-color: #eb722e !important
  }

  .article .howto-content .adv-content, .howto .howto-content .adv-content {
    position: relative;
    padding: 0 15px 0 80px
  }

  .article .howto-content .adv-content .num, .howto .howto-content .adv-content .num {
    font-size: 14px;
    border-radius: 50%;
    background-color: #66c05d;
    position: absolute;
    top: 0;
    left: -65px;
    width: 41px;
    height: 41px;
    line-height: 43px;
    text-indent: -1px;
    font-style: normal;
    text-align: center;
    color: #fff
  }

  .article .howto-content .adv-content div, .howto .howto-content .adv-content div {
    position: relative
  }

  .article .howto-content .adv-content table, .howto .howto-content .adv-content table {
    background-color: #fff;
    border-color: #333;
    border-width: 1px;
    width: 100%
  }

  .article .howto-content .adv-content table td, .howto .howto-content .adv-content table td {
    padding: 10px;
    border-color: #333
  }

  .article .howto-content .adv-content a, .howto .howto-content .adv-content a {
    color: #66c05d
  }

  .article .howto-content .adv-content a:hover, .howto .howto-content .adv-content a:hover {
    color: #4ba842
  }

  .article .howto-content .adv-content img, .howto .howto-content .adv-content img {
    display: block;
    max-width: 100%;
    height: auto
  }

  .article .howto-content .advice-content, .howto .howto-content .advice-content {
    margin: 0;
    padding: 0
  }

  .article .howto-content .advice-content .num, .howto .howto-content .advice-content .num {
    font-size: 14px;
    border-radius: 50%;
    background-color: #66c05d;
    position: absolute;
    top: 0;
    left: -65px;
    width: 41px;
    height: 41px;
    line-height: 43px;
    text-indent: -1px;
    font-style: normal;
    text-align: center;
    color: #fff
  }

  .article .howto-content .advice-content .block-header, .howto .howto-content .advice-content .block-header {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 15px
  }

  .article .howto-content .advice-content .block-header-mini, .howto .howto-content .advice-content .block-header-mini {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px
  }

  .article .howto-content .advice-content table, .howto .howto-content .advice-content table {
    margin: 25px 0
  }

  .article .howto-content .advice-content table td > *, .howto .howto-content .advice-content table td > * {
    position: relative;
    margin: 0;
    padding: 15px;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
    font-size: 14px
  }

  .article .howto-content .advice-content table td.text-content, .howto .howto-content .advice-content table td.text-content {
    border-spacing: 0 25px;
    vertical-align: top;
    letter-spacing: .2px;
    padding-left: 10px
  }

  .article .howto-content .advice-content table p, .howto .howto-content .advice-content table p {
    margin-bottom: 0
  }

  .article .howto-content .advice-content img, .howto .howto-content .advice-content img {
    display: block
  }

  .article .howto-content .advice-content p, .howto .howto-content .advice-content p {
    margin-bottom: 15px
  }

  .article .howto-content .advice-content .content-block, .howto .howto-content .advice-content .content-block {
    margin-bottom: 30px
  }

  .article .howto-content .advice-content .content-block tr > td:last-child, .howto .howto-content .advice-content .content-block tr > td:last-child {
    padding-left: 15px
  }

  .article .howto-content .advice-content .warning, .howto .howto-content .advice-content .warning {
    position: relative
  }

  .article .howto-content .advice-content .warning td:first-child, .howto .howto-content .advice-content .warning td:first-child {
    color: #fff;
    background-color: #66c05d;
    width: 100px;
    height: 100px
  }

  .article .howto-content .advice-content .warning td:first-child:after, .howto .howto-content .advice-content .warning td:first-child:after {
    font-size: 86px;
    font-weight: 600;
    content: "!";
    position: absolute;
    left: 40px;
    bottom: 0
  }

  .article .howto-content .advice-content .warning td:last-child, .howto .howto-content .advice-content .warning td:last-child {
    background: #ddedd3;
    padding: 15px 15px 15px 30px;
    vertical-align: middle
  }

  .article .howto-content .advice-content .warning p, .howto .howto-content .advice-content .warning p {
    margin: 0
  }

  .article .howto-content .advice-content li, .howto .howto-content .advice-content li {
    list-style-type: none;
    padding-left: 15px
  }

  .article .howto-content .advice-content li:before, .howto .howto-content .advice-content li:before {
    color: #97c599;
    content: "\\2022";
    padding-right: 5px
  }

  .article .howto-content .howto-subscribe, .howto .howto-content .howto-subscribe {
    font-size: 0;
    background: #66c05d;
    height: 100px;
    font-weight: 600;
    display: block;
    position: relative
  }

  .article .howto-content .howto-subscribe .howto-subscribe-title, .howto .howto-content .howto-subscribe .howto-subscribe-title {
    display: inline-block;
    font-size: 18px;
    text-transform: uppercase;
    color: #fff;
    margin-top: 40px;
    padding-left: 22px;
    float: left
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form, .howto .howto-content .howto-subscribe .howto-subscribe-form {
    margin-left: 10px;
    display: inline-block;
    margin-top: 30px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-input, .howto .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-input {
    width: 305px;
    height: 44px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-text, .howto .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-text {
    position: absolute;
    color: red;
    margin-top: -13px;
    font-size: 12px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-button, .howto .howto-content .howto-subscribe .howto-subscribe-button {
    position: absolute;
    width: 158px;
    height: 44px;
    background-color: #eede2a;
    margin: 30px 0 0 10px;
    text-transform: uppercase;
    line-height: normal;
    padding-top: 14px;
    font-size: 13px;
    text-decoration: none;
    text-align: center;
    color: #333
  }

  .article .howto-content .howto-subscribe .howto-subscribe-button:hover, .howto .howto-content .howto-subscribe .howto-subscribe-button:hover {
    background: #d4c411;
    -webkit-transition: all .2s ease;
    transition: all .2s ease
  }

  .article .howto-title, .howto .howto-title {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 0
  }

  .article .howto-title h1, .howto .howto-title h1 {
    font-size: 24px;
    text-transform: none
  }

  .article .howto-back, .howto .howto-back {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-right: 0
  }

  .article .views, .howto .views {
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 10px;
    color: #999;
    padding-left: 0
  }

  .article .howto-item, .howto .howto-item {
    background: 0;
    margin-bottom: 0;
    height: 420px
  }

  .article .howto-item .desc-block, .howto .howto-item .desc-block {
    position: relative;
    background-color: #fff;
    margin-bottom: 20px;
    margin-right: 19px;
    cursor: pointer;
    z-index: auto;
    width: 280px
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block, .howto .howto-item .desc-block {
      width: auto;
      margin: auto
    }
  }

  .article .howto-item .desc-block h2, .howto .howto-item .desc-block h2 {
    font-weight: 600;
    font-size: 14px;
    margin: 17px 10px;
    line-height: 18px;
    height: 42px;
    overflow: hidden;
    text-transform: none
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block h2, .howto .howto-item .desc-block h2 {
      font-size: 16px;
      margin: 43px 0 27px
    }
  }

  .article .howto-item .desc-block h2 a, .howto .howto-item .desc-block h2 a {
    color: #000;
    text-transform: none
  }

  .article .howto-item .desc-block h2 a:hover, .howto .howto-item .desc-block h2 a:hover {
    text-decoration: none
  }

  .article .howto-item .desc-block .howto-label, .howto .howto-item .desc-block .howto-label {
    position: absolute;
    top: 0;
    right: 0;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: 1
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-label, .howto .howto-item .desc-block .howto-label {
      z-index: 10;
      margin: 0 0 0 1px
    }
  }

  .article .howto-item .desc-block .howto-label-bottom, .howto .howto-item .desc-block .howto-label-bottom {
    position: absolute;
    top: 195px;
    left: 10px;
    padding: 0 0 0 20px;
    color: #fff;
    font-weight: 500;
    font-size: 11px;
    z-index: 2
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-label-bottom, .howto .howto-item .desc-block .howto-label-bottom {
      top: 217px
    }
  }

  .article .howto-item .desc-block .howto-label-stati:before, .howto .howto-item .desc-block .howto-label-stati:before {
    font-family: Leroy Merlin Icons, serif;
    content: "\\E96D";
    position: absolute;
    left: 0;
    top: 0
  }

  .article .howto-item .desc-block .howto-label-video:before, .howto .howto-item .desc-block .howto-label-video:before {
    font-family: Leroy Merlin Icons, serif;
    content: "\\E955";
    position: absolute;
    left: 0;
    top: 0
  }

  .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
    margin: 0 10px 15px;
    font-size: 12px;
    color: #666
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
      margin: 0
    }
  }

  @media (min-width: 992px) {
    .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
      display: none
    }
  }

  .article .howto-item .desc-block .desc-block, .howto .howto-item .desc-block .desc-block {
    width: auto;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    z-index: 10
  }

  .article .howto-item .desc-block .howto-button, .howto .howto-item .desc-block .howto-button {
    text-align: center;
    text-transform: uppercase;
    width: 260px;
    font-size: 12px;
    font-weight: 600;
    margin: 10px 10px 15px
  }

  .article .howto-item .desc-block .howto-views, .howto .howto-item .desc-block .howto-views {
    font-size: 10px;
    color: #999;
    margin: 0 10px 10px;
    text-transform: capitalize
  }

  .article .howto-item .desc-block hr, .howto .howto-item .desc-block hr {
    margin: 0 10px 8px;
    border-bottom-color: #d3d3d3
  }

  .article .howto-item .desc-block:hover, .howto .howto-item .desc-block:hover {
    z-index: 10
  }

  .article .howto-item .desc-block:hover .howto-desc, .howto .howto-item .desc-block:hover .howto-desc {
    display: block
  }

  .article .howto-item:hover .desc-block, .howto .howto-item:hover .desc-block {
    -webkit-box-shadow: 0 17px 10px hsla(0, 0, 63.1%, .5);
    box-shadow: 0 17px 10px hsla(0, 0, 63.1%, .5);
    z-index: 20
  }

  .howto-pagination {
    background-color: transparent;
    margin-bottom: 20px
  }

  .select2-dropdown {
    border: 1px solid #edecea;
    top: 0
  }

  .select2-container--default {
    font-size: 12px;
    color: #4f4f4f
  }

  .select2-container--default .select2-results__option[aria-selected=true] {
    background: 0;
    color: #4f4f4f;
    font-weight: 600
  }

  .select2-container--default .select2-results__option[aria-selected=true] i {
    display: inline;
    margin-right: 10px;
    font-size: 10px;
    color: #57bd62
  }

  .select2-container--default .select2-results__option[aria-selected=false] i {
    display: none
  }

  .select2-container.select2-container--focus .select2-selection--single, .select2-container.select2-container--open .select2-selection--single {
    border: 1px solid #edecea
  }

  .article .howto-content .advice-video, .howto .howto-content .advice-video {
    padding: 35px 58px 20px;
    position: relative
  }

  .article .howto-content .advice-video .howto-label, .howto .howto-content .advice-video .howto-label {
    position: absolute;
    top: 0;
    right: 0;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: auto;
    font-weight: 400
  }

  .video .video-data {
    width: 100%;
    position: relative
  }

  .video .video-data .video-preview {
    width: 100%;
    background: no-repeat 50%;
    background-size: cover
  }

  .video .video-data iframe {
    width: 100%;
    height: 100%;
    display: none
  }

  .video .video-data .play {
    background: transparent url(https://cdn.lemanapro.ru/lmru/image/upload/site/HHb9rl43HkKcoEc8wM1FvQ/play.webp);
    background-size: 70px 50px;
    cursor: pointer;
    height: 50px;
    left: 50%;
    margin: -25px 0 0 -35px;
    opacity: .8;
    position: absolute;
    top: 50%;
    width: 70px
  }

  .video .video-data .play:hover {
    background: transparent url(https://cdn.lemanapro.ru/lmru/image/upload/site/HHb9rl43HkKcoEc8wM1FvQ/play.webp);
    background-size: 70px 50px;
    opacity: 1
  }

  .article .howto-content .advice-video .video-data, .howto .howto-content .advice-video .video-data {
    text-align: center;
    height: 500px
  }

  .article .howto-content .advice-video .video-data .video-preview, .howto .howto-content .advice-video .video-data .video-preview {
    height: 500px
  }

  .article .wrapper.section > div, .pdp-section--article-reviews {
    background-color: #fff !important
  }

  .pdp-section--article-reviews {
    width: auto !important
  }

  .pdp-section--article-reviews .related-products-container__section-header {
    width: 100%;
    margin-left: auto;
    margin-right: auto
  }

  @media screen and (min-width: 1200px) {
    .pdp-section--article-reviews .related-products-container__section-header {
      width: 1180px
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    .pdp-section--article-reviews .related-products-container__section-header {
      width: 940px
    }
  }


  .container {
    margin-right: auto;
    margin-left: auto;
    padding-left: 10px;
    padding-right: 10px
  }

  @media (min-width: 768px) {
    .container {
      width: 768px
    }
  }
  @media (min-width: 992px) {
    .container {
      width: 972px
    }
  }
  @media (min-width: 1200px) {
    .container {
      width: 1200px
    }
  }

  .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 10px;
    padding-right: 10px
  }

  .row {
    margin-left: -10px;
    margin-right: -10px
  }

  .col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
    float: left
  }

  .col-xs-12 {
    width: 100%
  }

  .col-xs-11 {
    width: 91.6667%
  }

  .col-xs-10 {
    width: 83.3333%
  }

  .col-xs-9 {
    width: 75%
  }

  .col-xs-8 {
    width: 66.6667%
  }

  .col-xs-7 {
    width: 58.3333%
  }

  .col-xs-6 {
    width: 50%
  }

  .col-xs-5 {
    width: 41.6667%
  }

  .col-xs-4 {
    width: 33.3333%
  }

  .col-xs-3 {
    width: 25%
  }

  .col-xs-2 {
    width: 16.6667%
  }

  .col-xs-1 {
    width: 8.3333%
  }

  .col-xs-pull-12 {
    right: 100%
  }

  .col-xs-pull-11 {
    right: 91.6667%
  }

  .col-xs-pull-10 {
    right: 83.3333%
  }

  .col-xs-pull-9 {
    right: 75%
  }

  .col-xs-pull-8 {
    right: 66.6667%
  }

  .col-xs-pull-7 {
    right: 58.3333%
  }

  .col-xs-pull-6 {
    right: 50%
  }

  .col-xs-pull-5 {
    right: 41.6667%
  }

  .col-xs-pull-4 {
    right: 33.3333%
  }

  .col-xs-pull-3 {
    right: 25%
  }

  .col-xs-pull-2 {
    right: 16.6667%
  }

  .col-xs-pull-1 {
    right: 8.3333%
  }

  .col-xs-pull-0 {
    right: auto
  }

  .col-xs-push-12 {
    left: 100%
  }

  .col-xs-push-11 {
    left: 91.6667%
  }

  .col-xs-push-10 {
    left: 83.3333%
  }

  .col-xs-push-9 {
    left: 75%
  }

  .col-xs-push-8 {
    left: 66.6667%
  }

  .col-xs-push-7 {
    left: 58.3333%
  }

  .col-xs-push-6 {
    left: 50%
  }

  .col-xs-push-5 {
    left: 41.6667%
  }

  .col-xs-push-4 {
    left: 33.3333%
  }

  .col-xs-push-3 {
    left: 25%
  }

  .col-xs-push-2 {
    left: 16.6667%
  }

  .col-xs-push-1 {
    left: 8.3333%
  }

  .col-xs-push-0 {
    left: auto
  }

  .col-xs-offset-12 {
    margin-left: 100%
  }

  .col-xs-offset-11 {
    margin-left: 91.6667%
  }

  .col-xs-offset-10 {
    margin-left: 83.3333%
  }

  .col-xs-offset-9 {
    margin-left: 75%
  }

  .col-xs-offset-8 {
    margin-left: 66.6667%
  }

  .col-xs-offset-7 {
    margin-left: 58.3333%
  }

  .col-xs-offset-6 {
    margin-left: 50%
  }

  .col-xs-offset-5 {
    margin-left: 41.6667%
  }

  .col-xs-offset-4 {
    margin-left: 33.3333%
  }

  .col-xs-offset-3 {
    margin-left: 25%
  }

  .col-xs-offset-2 {
    margin-left: 16.6667%
  }

  .col-xs-offset-1 {
    margin-left: 8.3333%
  }

  .col-xs-offset-0 {
    margin-left: 0
  }

  @media (min-width: 768px) {
    .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
      float: left
    }

    .col-sm-12 {
      width: 100%
    }

    .col-sm-11 {
      width: 91.6667%
    }

    .col-sm-10 {
      width: 83.3333%
    }

    .col-sm-9 {
      width: 75%
    }

    .col-sm-8 {
      width: 66.6667%
    }

    .col-sm-7 {
      width: 58.3333%
    }

    .col-sm-6 {
      width: 50%
    }

    .col-sm-5 {
      width: 41.6667%
    }

    .col-sm-4 {
      width: 33.3333%
    }

    .col-sm-3 {
      width: 25%
    }

    .col-sm-2 {
      width: 16.6667%
    }

    .col-sm-1 {
      width: 8.3333%
    }

    .col-sm-pull-12 {
      right: 100%
    }

    .col-sm-pull-11 {
      right: 91.6667%
    }

    .col-sm-pull-10 {
      right: 83.3333%
    }

    .col-sm-pull-9 {
      right: 75%
    }

    .col-sm-pull-8 {
      right: 66.6667%
    }

    .col-sm-pull-7 {
      right: 58.3333%
    }

    .col-sm-pull-6 {
      right: 50%
    }

    .col-sm-pull-5 {
      right: 41.6667%
    }

    .col-sm-pull-4 {
      right: 33.3333%
    }

    .col-sm-pull-3 {
      right: 25%
    }

    .col-sm-pull-2 {
      right: 16.6667%
    }

    .col-sm-pull-1 {
      right: 8.3333%
    }

    .col-sm-pull-0 {
      right: auto
    }

    .col-sm-push-12 {
      left: 100%
    }

    .col-sm-push-11 {
      left: 91.6667%
    }

    .col-sm-push-10 {
      left: 83.3333%
    }

    .col-sm-push-9 {
      left: 75%
    }

    .col-sm-push-8 {
      left: 66.6667%
    }

    .col-sm-push-7 {
      left: 58.3333%
    }

    .col-sm-push-6 {
      left: 50%
    }

    .col-sm-push-5 {
      left: 41.6667%
    }

    .col-sm-push-4 {
      left: 33.3333%
    }

    .col-sm-push-3 {
      left: 25%
    }

    .col-sm-push-2 {
      left: 16.6667%
    }

    .col-sm-push-1 {
      left: 8.3333%
    }

    .col-sm-push-0 {
      left: auto
    }

    .col-sm-offset-12 {
      margin-left: 100%
    }

    .col-sm-offset-11 {
      margin-left: 91.6667%
    }

    .col-sm-offset-10 {
      margin-left: 83.3333%
    }

    .col-sm-offset-9 {
      margin-left: 75%
    }

    .col-sm-offset-8 {
      margin-left: 66.6667%
    }

    .col-sm-offset-7 {
      margin-left: 58.3333%
    }

    .col-sm-offset-6 {
      margin-left: 50%
    }

    .col-sm-offset-5 {
      margin-left: 41.6667%
    }

    .col-sm-offset-4 {
      margin-left: 33.3333%
    }

    .col-sm-offset-3 {
      margin-left: 25%
    }

    .col-sm-offset-2 {
      margin-left: 16.6667%
    }

    .col-sm-offset-1 {
      margin-left: 8.3333%
    }

    .col-sm-offset-0 {
      margin-left: 0
    }
  }
  @media (min-width: 992px) {
    .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
      float: left
    }

    .col-md-12 {
      width: 100%
    }

    .col-md-11 {
      width: 91.6667%
    }

    .col-md-10 {
      width: 83.3333%
    }

    .col-md-9 {
      width: 75%
    }

    .col-md-8 {
      width: 66.6667%
    }

    .col-md-7 {
      width: 58.3333%
    }

    .col-md-6 {
      width: 50%
    }

    .col-md-5 {
      width: 41.6667%
    }

    .col-md-4 {
      width: 33.3333%
    }

    .col-md-3 {
      width: 25%
    }

    .col-md-2 {
      width: 16.6667%
    }

    .col-md-1 {
      width: 8.3333%
    }

    .col-md-pull-12 {
      right: 100%
    }

    .col-md-pull-11 {
      right: 91.6667%
    }

    .col-md-pull-10 {
      right: 83.3333%
    }

    .col-md-pull-9 {
      right: 75%
    }

    .col-md-pull-8 {
      right: 66.6667%
    }

    .col-md-pull-7 {
      right: 58.3333%
    }

    .col-md-pull-6 {
      right: 50%
    }

    .col-md-pull-5 {
      right: 41.6667%
    }

    .col-md-pull-4 {
      right: 33.3333%
    }

    .col-md-pull-3 {
      right: 25%
    }

    .col-md-pull-2 {
      right: 16.6667%
    }

    .col-md-pull-1 {
      right: 8.3333%
    }

    .col-md-pull-0 {
      right: auto
    }

    .col-md-push-12 {
      left: 100%
    }

    .col-md-push-11 {
      left: 91.6667%
    }

    .col-md-push-10 {
      left: 83.3333%
    }

    .col-md-push-9 {
      left: 75%
    }

    .col-md-push-8 {
      left: 66.6667%
    }

    .col-md-push-7 {
      left: 58.3333%
    }

    .col-md-push-6 {
      left: 50%
    }

    .col-md-push-5 {
      left: 41.6667%
    }

    .col-md-push-4 {
      left: 33.3333%
    }

    .col-md-push-3 {
      left: 25%
    }

    .col-md-push-2 {
      left: 16.6667%
    }

    .col-md-push-1 {
      left: 8.3333%
    }

    .col-md-push-0 {
      left: auto
    }

    .col-md-offset-12 {
      margin-left: 100%
    }

    .col-md-offset-11 {
      margin-left: 91.6667%
    }

    .col-md-offset-10 {
      margin-left: 83.3333%
    }

    .col-md-offset-9 {
      margin-left: 75%
    }

    .col-md-offset-8 {
      margin-left: 66.6667%
    }

    .col-md-offset-7 {
      margin-left: 58.3333%
    }

    .col-md-offset-6 {
      margin-left: 50%
    }

    .col-md-offset-5 {
      margin-left: 41.6667%
    }

    .col-md-offset-4 {
      margin-left: 33.3333%
    }

    .col-md-offset-3 {
      margin-left: 25%
    }

    .col-md-offset-2 {
      margin-left: 16.6667%
    }

    .col-md-offset-1 {
      margin-left: 8.3333%
    }

    .col-md-offset-0 {
      margin-left: 0
    }
  }
  @media (min-width: 1200px) {
    .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
      float: left
    }

    .col-lg-12 {
      width: 100%
    }

    .col-lg-11 {
      width: 91.6667%
    }

    .col-lg-10 {
      width: 83.3333%
    }

    .col-lg-9 {
      width: 75%
    }

    .col-lg-8 {
      width: 66.6667%
    }

    .col-lg-7 {
      width: 58.3333%
    }

    .col-lg-6 {
      width: 50%
    }

    .col-lg-5 {
      width: 41.6667%
    }

    .col-lg-4 {
      width: 33.3333%
    }

    .col-lg-3 {
      width: 25%
    }

    .col-lg-2 {
      width: 16.6667%
    }

    .col-lg-1 {
      width: 8.3333%
    }

    .col-lg-pull-12 {
      right: 100%
    }

    .col-lg-pull-11 {
      right: 91.6667%
    }

    .col-lg-pull-10 {
      right: 83.3333%
    }

    .col-lg-pull-9 {
      right: 75%
    }

    .col-lg-pull-8 {
      right: 66.6667%
    }

    .col-lg-pull-7 {
      right: 58.3333%
    }

    .col-lg-pull-6 {
      right: 50%
    }

    .col-lg-pull-5 {
      right: 41.6667%
    }

    .col-lg-pull-4 {
      right: 33.3333%
    }

    .col-lg-pull-3 {
      right: 25%
    }

    .col-lg-pull-2 {
      right: 16.6667%
    }

    .col-lg-pull-1 {
      right: 8.3333%
    }

    .col-lg-pull-0 {
      right: auto
    }

    .col-lg-push-12 {
      left: 100%
    }

    .col-lg-push-11 {
      left: 91.6667%
    }

    .col-lg-push-10 {
      left: 83.3333%
    }

    .col-lg-push-9 {
      left: 75%
    }

    .col-lg-push-8 {
      left: 66.6667%
    }

    .col-lg-push-7 {
      left: 58.3333%
    }

    .col-lg-push-6 {
      left: 50%
    }

    .col-lg-push-5 {
      left: 41.6667%
    }

    .col-lg-push-4 {
      left: 33.3333%
    }

    .col-lg-push-3 {
      left: 25%
    }

    .col-lg-push-2 {
      left: 16.6667%
    }

    .col-lg-push-1 {
      left: 8.3333%
    }

    .col-lg-push-0 {
      left: auto
    }

    .col-lg-offset-12 {
      margin-left: 100%
    }

    .col-lg-offset-11 {
      margin-left: 91.6667%
    }

    .col-lg-offset-10 {
      margin-left: 83.3333%
    }

    .col-lg-offset-9 {
      margin-left: 75%
    }

    .col-lg-offset-8 {
      margin-left: 66.6667%
    }

    .col-lg-offset-7 {
      margin-left: 58.3333%
    }

    .col-lg-offset-6 {
      margin-left: 50%
    }

    .col-lg-offset-5 {
      margin-left: 41.6667%
    }

    .col-lg-offset-4 {
      margin-left: 33.3333%
    }

    .col-lg-offset-3 {
      margin-left: 25%
    }

    .col-lg-offset-2 {
      margin-left: 16.6667%
    }

    .col-lg-offset-1 {
      margin-left: 8.3333%
    }

    .col-lg-offset-0 {
      margin-left: 0
    }
  }

  .clearfix:before, .clearfix:after, .container:before, .container:after, .container-fluid:before, .container-fluid:after, .row:before, .row:after {
    content: " ";
    display: table
  }

  .clearfix:after, .container:after, .container-fluid:after, .row:after {
    clear: both
  }

  .visible-xs, .visible-sm, .visible-md, .visible-lg {
    display: none !important
  }

  .visible-xs-block, .visible-xs-inline, .visible-xs-inline-block, .visible-sm-block, .visible-sm-inline, .visible-sm-inline-block, .visible-md-block, .visible-md-inline, .visible-md-inline-block, .visible-lg-block, .visible-lg-inline, .visible-lg-inline-block {
    display: none !important
  }

  @media (max-width: 767px) {
    .visible-xs {
      display: block !important
    }

    table.visible-xs {
      display: table !important
    }

    tr.visible-xs {
      display: table-row !important
    }

    th.visible-xs, td.visible-xs {
      display: table-cell !important
    }
  }
  @media (max-width: 767px) {
    .visible-xs-block {
      display: block !important
    }
  }
  @media (max-width: 767px) {
    .visible-xs-inline {
      display: inline !important
    }
  }
  @media (max-width: 767px) {
    .visible-xs-inline-block {
      display: inline-block !important
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .visible-sm {
      display: block !important
    }

    table.visible-sm {
      display: table !important
    }

    tr.visible-sm {
      display: table-row !important
    }

    th.visible-sm, td.visible-sm {
      display: table-cell !important
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .visible-sm-block {
      display: block !important
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .visible-sm-inline {
      display: inline !important
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .visible-sm-inline-block {
      display: inline-block !important
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md {
      display: block !important
    }

    table.visible-md {
      display: table !important
    }

    tr.visible-md {
      display: table-row !important
    }

    th.visible-md, td.visible-md {
      display: table-cell !important
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-block {
      display: block !important
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-inline {
      display: inline !important
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .visible-md-inline-block {
      display: inline-block !important
    }
  }
  @media (min-width: 1200px) {
    .visible-lg {
      display: block !important
    }

    table.visible-lg {
      display: table !important
    }

    tr.visible-lg {
      display: table-row !important
    }

    th.visible-lg, td.visible-lg {
      display: table-cell !important
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-block {
      display: block !important
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-inline {
      display: inline !important
    }
  }
  @media (min-width: 1200px) {
    .visible-lg-inline-block {
      display: inline-block !important
    }
  }
  @media (max-width: 767px) {
    .hidden-xs {
      display: none !important
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .hidden-sm {
      display: none !important
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .hidden-md {
      display: none !important
    }
  }
  @media (min-width: 1200px) {
    .hidden-lg {
      display: none !important
    }
  }

  .visible-print {
    display: none !important
  }

  @media print {
    .visible-print {
      display: block !important
    }

    table.visible-print {
      display: table !important
    }

    tr.visible-print {
      display: table-row !important
    }

    th.visible-print, td.visible-print {
      display: table-cell !important
    }
  }

  .visible-print-block {
    display: none !important
  }

  @media print {
    .visible-print-block {
      display: block !important
    }
  }

  .visible-print-inline {
    display: none !important
  }

  @media print {
    .visible-print-inline {
      display: inline !important
    }
  }

  .visible-print-inline-block {
    display: none !important
  }

  @media print {
    .visible-print-inline-block {
      display: inline-block !important
    }
  }
  @media print {
    .hidden-print {
      display: none !important
    }
  }

  .article, .article section, .howto, .howto section {
    margin-left: auto;
    margin-right: auto
  }

  .article section, .howto section {
    width: 1150px
  }

  .article .left-block, .howto .left-block {
    padding-left: 0
  }

  .article h1, .howto h1 {
    margin-top: 0;
    font-size: 29px;
    color: #333;
    text-transform: uppercase;
    font-weight: 600
  }

  .article h2, .howto h2 {
    text-transform: uppercase;
    font-weight: 600;
    margin: 20px 0;
    font-size: 20px
  }

  .article .howto-content, .howto .howto-content {
    background-color: #fff;
    margin-bottom: 20px;
    padding: 0;
    font-size: 14px;
    height: auto
  }

  .article .howto-content.is-video-howto .howto-subscribe .howto-subscribe-form .howto-subscribe-input, .howto .howto-content.is-video-howto .howto-subscribe .howto-subscribe-form .howto-subscribe-input {
    width: 501px
  }

  .article .howto-content .main-img, .howto .howto-content .main-img {
    max-height: 100%;
    position: relative;
    width: 100%;
    margin-bottom: 30px
  }

  .article .howto-content .main-img img, .howto .howto-content .main-img img {
    width: 100%
  }

  .article .howto-content .main-img .howto-label, .howto .howto-content .main-img .howto-label {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: auto;
    font-weight: 400
  }

  .article .howto-content .btns, .howto .howto-content .btns {
    position: absolute;
    bottom: 8px;
    right: 11px;
    z-index: 2
  }

  .article .howto-content .btns .download-button, .howto .howto-content .btns .download-button {
    margin-left: 10px
  }

  .article .howto-content .bottom-block, .howto .howto-content .bottom-block {
    min-height: 80px;
    position: relative;
    margin-top: 20px;
    padding: 20px;
    border-top: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1
  }

  .article .howto-content .bottom-block .btns, .howto .howto-content .bottom-block .btns {
    bottom: 20px
  }

  .article .howto-content .bottom-block .social, .howto .howto-content .bottom-block .social {
    position: relative;
    clear: both;
    margin: 0;
    padding: 0
  }

  .article .howto-content .bottom-block .social .social-title, .howto .howto-content .bottom-block .social .social-title {
    line-height: 35px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 18px;
    display: inline-block
  }

  .article .howto-content .bottom-block .social .social-panel, .howto .howto-content .bottom-block .social .social-panel {
    display: inline-block;
    vertical-align: top;
    padding: 0;
    margin: 0;
    list-style-type: none
  }

  .article .howto-content .bottom-block .social .social-panel li, .howto .howto-content .bottom-block .social .social-panel li {
    display: inline-block;
    position: relative;
    background-color: #d3d3d3;
    height: 35px;
    width: 35px;
    border-radius: 2px
  }

  .article .howto-content .bottom-block .social .social-panel li span, .howto .howto-content .bottom-block .social .social-panel li span {
    height: 35px;
    width: 35px
  }

  .article .howto-content .bottom-block .social .social-panel li + li, .howto .howto-content .bottom-block .social .social-panel li + li {
    margin-left: 10px
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_facebook .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_facebook .ya-share2__badge {
    background-color: #3b5998 !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_vkontakte .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_vkontakte .ya-share2__badge {
    background-color: #48729e !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_twitter .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_twitter .ya-share2__badge {
    background-color: #00aced !important
  }

  .article .howto-content .bottom-block .social .social-panel .ya-share2__item_service_odnoklassniki .ya-share2__badge, .howto .howto-content .bottom-block .social .social-panel .ya-share2__item_service_odnoklassniki .ya-share2__badge {
    background-color: #eb722e !important
  }

  .article .howto-content .adv-content, .howto .howto-content .adv-content {
    position: relative;
    padding: 0 15px 0 80px
  }

  .article .howto-content .adv-content .num, .howto .howto-content .adv-content .num {
    font-size: 14px;
    border-radius: 50%;
    background-color: #66c05d;
    position: absolute;
    top: 0;
    left: -65px;
    width: 41px;
    height: 41px;
    line-height: 43px;
    text-indent: -1px;
    font-style: normal;
    text-align: center;
    color: #fff
  }

  .article .howto-content .adv-content div, .howto .howto-content .adv-content div {
    position: relative
  }

  .article .howto-content .adv-content h6, .howto .howto-content .adv-content h6 {
    font-size: 16px;
    margin: 30px 0;
    color: #333;
    line-height: 1.1;
    font-weight: 600
  }

  .article .howto-content .adv-content table, .howto .howto-content .adv-content table {
    background-color: #fff;
    border-color: #333;
    border-width: 1px;
    width: 100%
  }

  .article .howto-content .adv-content table td, .howto .howto-content .adv-content table td {
    padding: 10px;
    border-color: #333
  }

  .article .howto-content .adv-content a, .howto .howto-content .adv-content a {
    color: #66c05d
  }

  .article .howto-content .adv-content a:hover, .howto .howto-content .adv-content a:hover {
    color: #4ba842
  }

  .article .howto-content .adv-content img, .howto .howto-content .adv-content img {
    display: block;
    max-width: 100%;
    height: auto
  }

  .article .howto-content .advice-content, .howto .howto-content .advice-content {
    margin: 0;
    padding: 0
  }

  .article .howto-content .advice-content .num, .howto .howto-content .advice-content .num {
    font-size: 14px;
    border-radius: 50%;
    background-color: #66c05d;
    position: absolute;
    top: 0;
    left: -65px;
    width: 41px;
    height: 41px;
    line-height: 43px;
    text-indent: -1px;
    font-style: normal;
    text-align: center;
    color: #fff
  }

  .article .howto-content .advice-content .block-header, .howto .howto-content .advice-content .block-header {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 15px
  }

  .article .howto-content .advice-content .block-header-mini, .howto .howto-content .advice-content .block-header-mini {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px
  }

  .article .howto-content .advice-content table, .howto .howto-content .advice-content table {
    margin: 25px 0
  }

  .article .howto-content .advice-content table td > *, .howto .howto-content .advice-content table td > * {
    position: relative;
    margin: 0;
    padding: 15px;
    border: none;
    outline: 0;
    vertical-align: baseline;
    background: transparent;
    font-size: 14px
  }

  .article .howto-content .advice-content table td.text-content, .howto .howto-content .advice-content table td.text-content {
    border-spacing: 0 25px;
    vertical-align: top;
    letter-spacing: 0.2px;
    padding-left: 10px
  }

  .article .howto-content .advice-content table p, .howto .howto-content .advice-content table p {
    margin-bottom: 0
  }

  .article .howto-content .advice-content img, .howto .howto-content .advice-content img {
    display: block
  }

  .article .howto-content .advice-content p, .howto .howto-content .advice-content p {
    margin-bottom: 15px
  }

  .article .howto-content .advice-content .content-block, .howto .howto-content .advice-content .content-block {
    margin-bottom: 30px
  }

  .article .howto-content .advice-content .content-block tr > td:last-child, .howto .howto-content .advice-content .content-block tr > td:last-child {
    padding-left: 15px
  }

  .article .howto-content .advice-content .green, .howto .howto-content .advice-content .green {
    color: #97c599;
    font-weight: 600
  }

  .article .howto-content .advice-content .warning, .howto .howto-content .advice-content .warning {
    position: relative
  }

  .article .howto-content .advice-content .warning td:first-child, .howto .howto-content .advice-content .warning td:first-child {
    color: #fff;
    background-color: #66c05d;
    width: 100px;
    height: 100px
  }

  .article .howto-content .advice-content .warning td:first-child:after, .howto .howto-content .advice-content .warning td:first-child:after {
    font-size: 86px;
    font-weight: 600;
    content: "!";
    position: absolute;
    left: 40px;
    bottom: 0
  }

  .article .howto-content .advice-content .warning td:last-child, .howto .howto-content .advice-content .warning td:last-child {
    background: #ddedd3;
    padding: 15px 15px 15px 30px;
    vertical-align: middle
  }

  .article .howto-content .advice-content .warning p, .howto .howto-content .advice-content .warning p {
    margin: 0
  }

  .article .howto-content .advice-content li, .howto .howto-content .advice-content li {
    list-style-type: none;
    padding-left: 15px
  }

  .article .howto-content .advice-content li:before, .howto .howto-content .advice-content li:before {
    color: #97c599;
    content: "•";
    padding-right: 5px
  }

  .article .howto-content .advice-content .text-table, .howto .howto-content .advice-content .text-table {
    border-spacing: 0;
    border-collapse: collapse;
    margin-bottom: 15px
  }

  .article .howto-content .advice-content .text-table th, .howto .howto-content .advice-content .text-table th {
    border: 1px solid;
    padding: 15px
  }

  .article .howto-content .advice-content .no-border td, .article .howto-content .advice-content .no-border th, .howto .howto-content .advice-content .no-border td, .howto .howto-content .advice-content .no-border th {
    border: 0
  }

  .article .howto-content .advice-body, .howto .howto-content .advice-body {
    background: #fff;
    position: relative
  }

  .article .howto-content .advice-body__img, .howto .howto-content .advice-body__img {
    position: relative;
    width: 100%;
    height: 380px;
    margin-bottom: 30px
  }

  .article .howto-content .advice-body__img img, .howto .howto-content .advice-body__img img {
    max-height: 100%;
    height: 100%
  }

  .article .howto-content .advice-body__categories, .howto .howto-content .advice-body__categories {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2
  }

  .article .howto-content .advice-body__categories:after, .howto .howto-content .advice-body__categories:after {
    clear: both;
    content: "";
    display: table
  }

  .article .howto-content .advice-body__category, .howto .howto-content .advice-body__category {
    float: right;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff
  }

  .article .howto-content .advice-body-list__item, .howto .howto-content .advice-body-list__item {
    list-style: none;
    padding: 20px 20px 50px 100px;
    position: relative
  }

  .article .howto-content .advice-body-list__item h2, .howto .howto-content .advice-body-list__item h2 {
    color: #66c05d;
    font-size: 22px;
    margin: 0 0 30px;
    font-weight: 400
  }

  .article .howto-content .advice-body-list__item h3, .howto .howto-content .advice-body-list__item h3 {
    color: #66c05d;
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 40px
  }

  .article .howto-content .advice-body-list__item h4, .howto .howto-content .advice-body-list__item h4 {
    font-size: 18px;
    font-weight: 600;
    color: #66c05d;
    margin-bottom: 25px
  }

  .article .howto-content .advice-body-list__item h5, .howto .howto-content .advice-body-list__item h5 {
    color: #66c05d;
    font-weight: 600;
    margin: 0 0 20px;
    font-size: 16px
  }

  .article .howto-content .advice-body-list__item h6, .howto .howto-content .advice-body-list__item h6 {
    color: #66c05d;
    font-weight: 400;
    margin: 0 0 20px;
    font-size: 16px
  }

  .article .howto-content .advice-body-list__item p, .howto .howto-content .advice-body-list__item p {
    font-size: 12px;
    margin-bottom: 20px
  }

  .article .howto-content .advice-body-list__item figure, .howto .howto-content .advice-body-list__item figure {
    margin: 0 0 25px
  }

  .article .howto-content .advice-body-list__item figure div, .howto .howto-content .advice-body-list__item figure div {
    width: 250px;
    text-align: center
  }

  .article .howto-content .advice-body-list__item figure span, .howto .howto-content .advice-body-list__item figure span {
    width: 570px
  }

  .article .howto-content .advice-body-list__item ul, .howto .howto-content .advice-body-list__item ul {
    margin: 0
  }

  .article .howto-content .advice-body-list__item ul li, .howto .howto-content .advice-body-list__item ul li {
    list-style: none;
    position: relative;
    padding: 0 0 0 18px
  }

  .article .howto-content .advice-body-list__item ul li:after, .howto .howto-content .advice-body-list__item ul li:after {
    content: "•";
    font-size: 18px;
    line-height: 18px;
    color: #66c05d;
    position: absolute;
    left: 0;
    top: 0;
    width: 18px
  }

  .article .howto-content .advice-body-list__item > :first-child, .howto .howto-content .advice-body-list__item > :first-child {
    margin: 0 0 30px
  }

  .article .howto-content .advice-body-list__item > :last-child, .article .howto-content .advice-body .social-color .share, .howto .howto-content .advice-body-list__item > :last-child, .howto .howto-content .advice-body .social-color .share {
    margin-bottom: 0
  }

  .article .howto-content .advice-body-list__number, .howto .howto-content .advice-body-list__number {
    position: absolute;
    left: 26px;
    top: 0;
    background: #66c05d;
    width: 59px;
    height: 59px;
    border-radius: 50%;
    text-align: center;
    line-height: 59px;
    font-weight: 600;
    font-size: 14px;
    color: #fff
  }

  .article .howto-content .advice-body .social-color_single, .howto .howto-content .advice-body .social-color_single {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .article .howto-content .advice-body .social-color_video, .howto .howto-content .advice-body .social-color_video {
    padding: 0;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .article .howto-content .advice-body .social-color_video .social-color__item.btn + .btn, .howto .howto-content .advice-body .social-color_video .social-color__item.btn + .btn {
    margin-left: 8px
  }

  .article .howto-content .advice-video, .howto .howto-content .advice-video {
    padding: 35px 58px 20px;
    position: relative
  }

  .article .howto-content .advice-video .howto-label, .howto .howto-content .advice-video .howto-label {
    position: absolute;
    top: 0;
    right: 0;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: auto;
    font-weight: 400
  }

  .article .howto-content .advice-video .video-data, .howto .howto-content .advice-video .video-data {
    text-align: center;
    height: 500px
  }

  .article .howto-content .advice-video .video-data .video-preview, .howto .howto-content .advice-video .video-data .video-preview {
    height: 500px
  }

  .article .howto-content .howto-subscribe, .howto .howto-content .howto-subscribe {
    font-size: 0;
    background: #66c05d;
    height: 100px;
    font-weight: 600;
    display: block;
    position: relative
  }

  .article .howto-content .howto-subscribe .howto-subscribe-title, .howto .howto-content .howto-subscribe .howto-subscribe-title {
    display: inline-block;
    font-size: 18px;
    text-transform: uppercase;
    color: #fff;
    margin-top: 40px;
    padding-left: 22px;
    float: left
  }

  .article .howto-content .howto-subscribe .has-error .howto-subscribe-input, .howto .howto-content .howto-subscribe .has-error .howto-subscribe-input {
    border-color: red
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form, .howto .howto-content .howto-subscribe .howto-subscribe-form {
    margin-left: 10px;
    display: inline-block;
    margin-top: 30px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-input, .howto .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-input {
    width: 305px;
    height: 44px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-text, .howto .howto-content .howto-subscribe .howto-subscribe-form .howto-subscribe-text {
    position: absolute;
    color: red;
    margin-top: -13px;
    font-size: 12px
  }

  .article .howto-content .howto-subscribe .howto-subscribe-button, .howto .howto-content .howto-subscribe .howto-subscribe-button {
    position: absolute;
    width: 158px;
    height: 44px;
    background-color: #eede2a;
    margin: 30px 0 0 10px;
    text-transform: uppercase;
    line-height: normal;
    padding-top: 14px;
    font-size: 13px;
    text-decoration: none;
    text-align: center;
    color: #333
  }

  .article .howto-content .howto-subscribe .howto-subscribe-button:hover, .howto .howto-content .howto-subscribe .howto-subscribe-button:hover {
    background: #d4c411;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease
  }

  .article .howto-title, .howto .howto-title {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 0
  }

  .article .howto-title h1, .howto .howto-title h1 {
    font-size: 24px;
    text-transform: none
  }

  .article .howto-back, .howto .howto-back {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-right: 0
  }

  .article .views, .howto .views {
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 10px;
    color: #999;
    padding-left: 0
  }

  .article .more-howto > div, .howto .more-howto > div {
    padding: 0
  }

  .article .see-also, .howto .see-also {
    margin: 15px 0 20px;
    padding-left: 0
  }

  .article .see-also h2, .howto .see-also h2 {
    text-transform: none;
    font-size: 22px
  }

  .article .howto-item, .howto .howto-item {
    background: none;
    margin-bottom: 0;
    height: 420px
  }

  .article .howto-item .desc-block, .howto .howto-item .desc-block {
    position: relative;
    background-color: #fff;
    margin-bottom: 20px;
    margin-right: 19px;
    cursor: pointer;
    z-index: auto;
    width: 280px
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block, .howto .howto-item .desc-block {
      width: auto;
      margin: auto
    }
  }

  .article .howto-item .desc-block h2, .howto .howto-item .desc-block h2 {
    font-weight: 600;
    font-size: 14px;
    margin: 17px 10px;
    line-height: 18px;
    height: 42px;
    overflow: hidden;
    text-transform: none
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block h2, .howto .howto-item .desc-block h2 {
      font-size: 16px;
      margin: 43px 0 27px
    }
  }

  .article .howto-item .desc-block h2 a, .howto .howto-item .desc-block h2 a {
    color: #000;
    text-transform: none
  }

  .article .howto-item .desc-block h2 a:hover, .howto .howto-item .desc-block h2 a:hover {
    text-decoration: none
  }

  .article .howto-item .desc-block .howto-label, .howto .howto-item .desc-block .howto-label {
    position: absolute;
    top: 0;
    right: 0;
    background: #66c05d;
    padding: 1px 10px;
    margin: 0 0 3px 3px;
    font-size: 12px;
    color: #fff;
    z-index: 1
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-label, .howto .howto-item .desc-block .howto-label {
      z-index: 10;
      margin: 0 0 0 1px
    }
  }

  .article .howto-item .desc-block .howto-label-bottom, .howto .howto-item .desc-block .howto-label-bottom {
    position: absolute;
    top: 195px;
    left: 10px;
    padding: 0 0 0 20px;
    color: #fff;
    font-weight: 500;
    font-size: 11px;
    z-index: 2
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-label-bottom, .howto .howto-item .desc-block .howto-label-bottom {
      top: 217px
    }
  }

  .article .howto-item .desc-block .howto-label-stati:before, .howto .howto-item .desc-block .howto-label-stati:before {
    font-family: Leroy Merlin Icons, serif;
    content: "\\e96d";
    position: absolute;
    left: 0;
    top: 0
  }

  .article .howto-item .desc-block .howto-label-video:before, .howto .howto-item .desc-block .howto-label-video:before {
    font-family: Leroy Merlin Icons, serif;
    content: "\\e955";
    position: absolute;
    left: 0;
    top: 0
  }

  .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
    margin: 0 10px 15px;
    font-size: 12px;
    color: #666
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
      margin: 0
    }
  }

  @media (min-width: 992px) {
    .article .howto-item .desc-block .howto-desc, .howto .howto-item .desc-block .howto-desc {
      display: none
    }
  }

  .article .howto-item .desc-block .desc-block, .howto .howto-item .desc-block .desc-block {
    width: auto;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    z-index: 10
  }

  .article .howto-item .desc-block .howto-button, .howto .howto-item .desc-block .howto-button {
    text-align: center;
    text-transform: uppercase;
    width: 260px;
    font-size: 12px;
    font-weight: 600;
    margin: 10px 10px 15px
  }

  .article .howto-item .desc-block .howto-views, .howto .howto-item .desc-block .howto-views {
    font-size: 10px;
    color: #999;
    margin: 0 10px 10px;
    text-transform: capitalize
  }

  .article .howto-item .desc-block hr, .howto .howto-item .desc-block hr {
    margin: 0 10px 8px;
    border-bottom-color: #d3d3d3
  }

  .article .howto-item .desc-block:hover, .howto .howto-item .desc-block:hover {
    z-index: 10
  }

  .article .howto-item .desc-block:hover .howto-desc, .howto .howto-item .desc-block:hover .howto-desc {
    display: block
  }

  .article .howto-item:hover .desc-block, .howto .howto-item:hover .desc-block {
    -webkit-box-shadow: 0 17px 10px hsla(0, 0%, 63.1%, 0.5);
    box-shadow: 0 17px 10px hsla(0, 0%, 63.1%, 0.5);
    z-index: 20
  }

  .top-page-wrapper {
    margin-bottom: 0;
  }

  .main-article-image {
    height: 390px;
    position: relative;
  }

  .main-article-image:before,
  .main-article-image:after {
    content: " ";
    display: table;
  }

  .main-article-image:after {
    clear: both;
  }

  @media (max-width: 767px) {
    .main-article-image {
      padding: 0;
    }
  }
  @media (min-width: 600px) {
    .main-article-image {
      height: 553px;
    }
  }

  .main-article-image__title-wrapper {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    right: 0;
    padding: 0 8px;
  }

  .main-article-image__image,
  .main-article-image__video {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .main-article-image__image::before,
  .main-article-image__video::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to bottom, rgba(73, 72, 72, 0), rgba(73, 72, 72, 0.3) 27%, #494848);
    opacity: .6;
  }

  .main-article-image iframe {
    width: 100%;
    height: 100%;
    display: none;
  }

  .main-article-image__bg-container {
    display: block;
    height: 100%;
  }

  .main-article-image__bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .main-article-image__play {
    background: url('https://lemanapro.ru/etc/designs/elbrus/images/articles-play.svg');
    cursor: pointer;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    position: absolute;
    height: 159px;
    width: 159px;
    background-size: 159px 159px;
  }

  @media (min-width: 600px) {
    .main-article-image__play {
      top: 50%;
    }
  }
  @media (max-width: 767px) {
    .main-article-image__play {
      height: 95px;
      width: 95px;
      background-size: 95px 95px;
    }
  }

  .main-article-image__title {
    font-size: 24px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    margin-bottom: 16px;
    color: #ffffff;
  }

  .main-article-image__additional-info {
    color: #ffffff;
    font-size: 11px;
    letter-spacing: 0.8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .main-article-image__tag {
    text-transform: uppercase;
    border: 1px solid #ffffff;
    padding: 5px 15px;
    margin-right: 5px;
  }

  .main-article-image__date {
    padding: 5px 0;
  }

  .paginator-show-more {
    display: none;
    justify-content: center;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
  }

  .paginator-show-more {
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #66c05d;
  }

  @media (max-width: 767px) {
    .paginator-show-more {
      display: flex;
    }

    .pagination-page-numbers {
      display: none;
    }
  }

  .articles {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }

  .articles-card-list__card-loading {
    display: none;
  }

  .spinner-ajax.loading {
    top: 0;
    position: relative;
  }

  .articles-show-more {
    width: 45%;
    margin-top: 3%;
    margin-bottom: 3%;
    display: flex;
    justify-content: center;
  }

  .articles-show-more p {
    margin: 0 0 0 8%;
  }

  .left-menu-item {
    border: solid 1px #e3e3e3;
    margin-bottom: 7%;
  }

  .article-type-header {
    display: flex;
    flex-direction: row;
    margin: 9px 0 3px 0;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
  }

  .article-type-header p {
    width: 50%;
    margin: 2% 0 2% 0;
  }

  .articles-type-img-container {
    display: flex;
    width: 50%;
    justify-content: flex-end;
  }

  .articles-type-img {
    height: 100%;
    width: 25%;
    display: flex;
    justify-content: flex-end;
  }

  .dropdown-arrow {
    width: 7px;
    height: 5px;
    align-self: center;
  }

  .articles-container {
    display: flex;
    flex-direction: row;
  }

  .articles-type__active {
    display: none;
    width: 5px;
    height: 30px;
    background-color: #66c05d;
  }

  .article-type-li {
    display: flex !important;
    flex-direction: row;
    margin: 1% 0 1% 0;
    font-size: 12px;
    height: 27px;
  }

  .articles-type__active.article-type-active {
    display: block;
  }

  .article-type-link {
    align-self: center;
    margin-left: 8%;
    cursor: pointer;
  }

  .article-type-link-active {
    color: #333333;
    margin-left: 7%;
  }

  .articles-right-space {
    padding-right: 0;
  }

  .articles-left-menu-element {
    display: flex;
    margin-bottom: 8%;
    border: solid 1px #e3e3e3;
    flex-direction: column;
  }

  .articles-left-menu-element ul {
    padding-left: 0;
    margin-bottom: 13px;
  }

  .left-gap {
    width: 7%;
  }

  .right-gap {
    width: 8%;
  }

  a {
    color: #66c05d;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease
  }

  a, a:focus, a:hover {
    text-decoration: none
  }

  a:focus, a:hover {
    color: #4ba842
  }

  .articles-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
  }

  .articles-content .article-link:nth-child(4), .articles-content .article-link:nth-child(6), .articles-content .article-link:nth-child(9) {
    margin-right: 0
  }

  .articles-content .article-link:first-child {
    height: 330px;
    width: 100%
  }

  .articles-content .article-link:first-child .article-preview {
    height: 100%
  }

  .articles-content .article-link:first-child .article-preview__img {
    position: absolute;
    height: 100%
  }

  .articles-content .article-link:first-child .article-preview__block {
    z-index: 10;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: max-content 24px;
    grid-template-areas: "title title title" "infoHow date social";
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0
  }

  @media (min-width: 768px) {
    .articles-content .article-link:first-child .article-preview__block .article-preview__info-date {
      margin: 0 25%
    }
  }

  .articles-content .article-link:first-child .article-preview__info-how {
    border-radius: 2px;
    border: 1px solid #fff;
    padding: 5px 14px;
    text-transform: uppercase;
    height: 24px;
    line-height: 1;
    color: #fff;
    text-align: center;
    width: -moz-max-content;
    width: max-content
  }

  .articles-content .article-link:first-child .article-preview__info-date {
    height: 24px;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }

  .articles-content .article-link:first-child .article-preview__title {
    font-size: 21px;
    color: #fff;
    line-height: 1.24;
    padding: 0;
    margin-bottom: 15px
  }

  .articles-content .article-link:first-child .article-preview__social {
    margin: 0;
    padding: 0;
    height: 24px
  }

  .articles-content .article-link:first-child .article-preview__discussion, .articles-content .article-link:first-child .article-preview__discussion i, .articles-content .article-link:first-child .article-preview__likes, .articles-content .article-link:first-child .article-preview__likes i, .articles-content .article-link:first-child .article-preview__views, .articles-content .article-link:first-child .article-preview__views i {
    color: #fff
  }

  .articles-content .article-link:first-child .article-preview__deck {
    display: none
  }

  .articles-content .article-link:first-child .article-preview__img-container {
    position: static
  }

  .articles-content .article-link:first-child .play-video-rectangle {
    height: 150px
  }

  @media (min-width: 768px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      height: 330px;
      width: 100%;
      width: 49%
    }

    .articles-content .article-link:nth-child(5) .article-preview, .articles-content .article-link:nth-child(6) .article-preview {
      height: 100%
    }

    .articles-content .article-link:nth-child(5) .article-preview__img, .articles-content .article-link:nth-child(6) .article-preview__img {
      position: absolute;
      height: 100%
    }

    .articles-content .article-link:nth-child(5) .article-preview__block, .articles-content .article-link:nth-child(6) .article-preview__block {
      z-index: 10;
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: max-content 24px;
      grid-template-areas: "title title title" "infoHow date social";
      height: auto;
      position: absolute;
      bottom: 0;
      left: 0
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-how, .articles-content .article-link:nth-child(6) .article-preview__info-how {
      border-radius: 2px;
      border: 1px solid #fff;
      padding: 5px 14px;
      text-transform: uppercase;
      height: 24px;
      line-height: 1;
      color: #fff;
      text-align: center;
      width: -moz-max-content;
      width: max-content
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__info-date {
      height: 24px;
      color: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center
    }

    .articles-content .article-link:nth-child(5) .article-preview__title, .articles-content .article-link:nth-child(6) .article-preview__title {
      font-size: 21px;
      color: #fff;
      line-height: 1.24;
      padding: 0;
      margin-bottom: 15px
    }

    .articles-content .article-link:nth-child(5) .article-preview__social, .articles-content .article-link:nth-child(6) .article-preview__social {
      margin: 0;
      padding: 0;
      height: 24px
    }

    .articles-content .article-link:nth-child(5) .article-preview__discussion, .articles-content .article-link:nth-child(5) .article-preview__discussion i, .articles-content .article-link:nth-child(5) .article-preview__likes, .articles-content .article-link:nth-child(5) .article-preview__likes i, .articles-content .article-link:nth-child(5) .article-preview__views, .articles-content .article-link:nth-child(5) .article-preview__views i, .articles-content .article-link:nth-child(6) .article-preview__discussion, .articles-content .article-link:nth-child(6) .article-preview__discussion i, .articles-content .article-link:nth-child(6) .article-preview__likes, .articles-content .article-link:nth-child(6) .article-preview__likes i, .articles-content .article-link:nth-child(6) .article-preview__views, .articles-content .article-link:nth-child(6) .article-preview__views i {
      color: #fff
    }

    .articles-content .article-link:nth-child(5) .article-preview__deck, .articles-content .article-link:nth-child(6) .article-preview__deck {
      display: none
    }

    .articles-content .article-link:nth-child(5) .article-preview__img-container, .articles-content .article-link:nth-child(6) .article-preview__img-container {
      position: static
    }

    .articles-content .article-link:nth-child(5) .play-video-rectangle, .articles-content .article-link:nth-child(6) .play-video-rectangle {
      height: 120px
    }
  }

  @media (min-width: 768px) and (min-width: 768px) {
    .articles-content .article-link:nth-child(5) .article-preview__block .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__block .article-preview__info-date {
      margin: 0 25%
    }
  }

  .articles-content .article-link:first-child {
    max-width: 100%;
    margin-right: 0
  }

  .articles-content .article-link:first-child .article-preview:before {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(73, 72, 72, 0)), color-stop(19%, rgba(73, 72, 72, 0.3)), to(#494848));
    background: linear-gradient(180deg, rgba(73, 72, 72, 0) 0%, rgba(73, 72, 72, 0.3) 19%, #494848);
    opacity: 0.6;
    z-index: 10
  }

  @media (max-width: 767px) {
    .articles-content .article-link:first-child .article-preview__block {
      grid-template-columns:auto auto auto;
      grid-template-rows: 24px max-content 24px;
      grid-template-areas: "infoHow infoHow infoHow" "title title title" "social social date"
    }

    .articles-content .article-link:first-child .article-preview__title {
      margin-top: 12px
    }

    .articles-content .article-link:first-child .article-preview__info-date {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end
    }
  }

  @media (min-width: 768px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      max-width: 436px
    }

    .articles-content .article-link:nth-child(5) .article-preview:before, .articles-content .article-link:nth-child(6) .article-preview:before {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: -webkit-gradient(linear, left top, left bottom, from(rgba(73, 72, 72, 0)), color-stop(19%, rgba(73, 72, 72, 0.3)), to(#494848));
      background: linear-gradient(180deg, rgba(73, 72, 72, 0) 0%, rgba(73, 72, 72, 0.3) 19%, #494848);
      opacity: 0.6;
      z-index: 10
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    .articles-content .article-link:nth-child(5) .article-preview__block, .articles-content .article-link:nth-child(6) .article-preview__block {
      grid-template-columns:auto auto auto;
      grid-template-rows: 24px max-content 24px;
      grid-template-areas: "infoHow infoHow infoHow" "title title title" "social social date"
    }

    .articles-content .article-link:nth-child(5) .article-preview__title, .articles-content .article-link:nth-child(6) .article-preview__title {
      margin-top: 12px
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__info-date {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      max-width: 372px
    }
  }

  .play-video-rectangle {
    width: auto !important
  }

  .article-link {
    width: 32%;
    margin-bottom: 2%;
    margin-right: 2%
  }

  @media (max-width: 767px) {
    .article-link {
      max-width: 100%;
      width: 100%;
      margin-right: 0
    }
  }

  .article-preview {
    width: 100%;
    height: 436px;
    border: 1px solid #eaeaea;
    position: relative
  }

  .article-preview__img {
    width: 100%;
    display: block;
    height: 214px;
    -o-object-position: center;
    object-position: center;
    -o-object-fit: cover;
    object-fit: cover
  }

  .article-preview__img:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(73, 72, 72, 0)), color-stop(27%, rgba(73, 72, 72, 0.3)), to(#494848));
    background-image: linear-gradient(180deg, rgba(73, 72, 72, 0), rgba(73, 72, 72, 0.3) 27%, #494848);
    opacity: 0.6
  }

  .article-preview__img-container {
    position: relative
  }

  .article-preview .play-video-rectangle {
    width: 107px;
    height: 107px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
  }

  .article-preview__info-how {
    color: #4fac46;
    text-transform: uppercase;
    white-space: nowrap;
    grid-area: infoHow;
    margin-right: 10px
  }

  .article-preview__info-date, .article-preview__info-how {
    display: inline-block;
    font-size: 11px;
    letter-spacing: 0.8px
  }

  .article-preview__info-date {
    color: #adadad;
    grid-area: date
  }

  .article-preview__block {
    padding: 20px;
    height: 222px;
    display: grid;
    grid-template-columns: min-content auto;
    grid-template-rows: 15px 134px 24px;
    grid-template-areas: "infoHow date date" "title title title" "social social social"
  }

  @media (max-width: 767px) {
    .article-preview__block {
      grid-template-rows:15px 87px 24px
    }
  }

  .article-preview__title {
    font-weight: 700;
    color: #494848;
    grid-area: title;
    overflow: hidden
  }

  .article-preview__deck, .article-preview__title {
    font-size: 16px;
    line-height: 25px;
    padding-top: 10px;
    display: inline
  }

  .article-preview__deck {
    color: #adadad;
    grid-area: deck;
    font-weight: 400
  }

  .article-preview__social {
    font-size: 13px;
    line-height: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-top: 10px;
    margin-top: auto;
    grid-area: social
  }

  .article-preview__social div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .article-preview__social-icon {
    padding-right: 7px;
    font-size: 15px
  }

  .article-preview__views {
    color: #686868;
    margin-right: 20px
  }

  .article-preview__views i {
    color: #b1bec1
  }

  .article-preview__views--disabled {
    color: #363636
  }

  .article-preview__views--disabled i {
    color: #e3e3e3
  }

  .article-preview__discussion {
    color: #449fcc;
    margin-right: 20px
  }

  .article-preview__discussion--disabled, .article-preview__discussion--disabled i {
    color: #449fcc
  }

  .article-preview__likes {
    color: #ff5e35
  }

  .article-preview__likes--disabled, .article-preview__likes--disabled i {
    color: #ff6b46
  }

  @media (max-width: 991px) {
    .article-preview {
      height: 400px
    }
  }

  @media (max-width: 767px) {
    .article-preview {
      height: 336px
    }
  }

  @media (max-width: 991px) {
    .article-preview__img {
      height: 184px
    }
  }

  @media (max-width: 767px) {
    .article-preview__img {
      height: 164px
    }
  }

  @media (max-width: 991px) {
    .article-preview__block {
      height: 216px;
      padding: 19px 15px 23px
    }
  }

  @media (max-width: 767px) {
    .article-preview__block {
      height: 172px;
      padding: 16px 14px 20px
    }
  }

  @media (max-width: 991px) {
    .article-preview__text {
      line-height: 22px
    }
  }

  .articles-tab-filter {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 0 33px;
    position: relative
  }

  @media (max-width: 767px) {
    .articles-tab-filter {
      padding-right: 20px
    }
  }

  .articles-tab-filter:after {
    content: "";
    position: absolute;
    background-color: #e3e3e3;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px
  }

  .articles-tab-filter__item {
    position: relative;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    background-color: #fff;
    border: 1px solid #e3e3e3;
    border-right: none;
    color: #333;
    min-width: 150px;
    height: 47px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.2px;
    margin-right: 24px;
    -webkit-transition: none;
    transition: none;
    text-transform: uppercase;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .articles-tab-filter__item {
      min-width: -webkit-max-content;
      min-width: -moz-max-content;
      min-width: max-content;
      width: 100%
    }
  }

  .articles-tab-filter__item:before {
    content: "";
    display: block;
    position: absolute;
    top: -1px;
    right: 0;
    bottom: -1px;
    width: 100%;
    z-index: -1;
    -webkit-transform: skewX(39deg);
    transform: skewX(39deg);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 2px;
    background: #fff;
    border: 1px solid #e3e3e3;
    border-left: none
  }

  .articles-tab-filter__item:first-child {
    z-index: 10
  }

  .articles-tab-filter__item:nth-child(2) {
    z-index: 4
  }

  .articles-tab-filter__item:nth-child(3) {
    z-index: 3
  }

  .articles-tab-filter__item.active {
    max-width: 185px;
    color: #fff
  }

  .articles-tab-filter__item.active, .articles-tab-filter__item.active:before {
    background-color: #69be62;
    border-color: #69be62
  }

  h2.page-title {
    margin: 0;
    font-size: 36px;
    font-weight: 600;
    color: #000
  }

  .page-title, .title-panel-inner {
    margin-left: -10px;
    margin-right: -10px
  }

  .page-title:after, .page-title:before {
    content: " ";
    display: table
  }

  .page-title:after {
    clear: both
  }

  .page-title .page-title-inner, .page-title__inner {
    position: relative;
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px
  }

  .page-title .page-title-inner, .page-title .page-title-inner-additional, .page-title__additional, .page-title__plp {
    margin: 0 3px 0 auto;
    font-weight: 600;
    display: inline;
    padding-bottom: 10px
  }

  @media (min-width: 768px) {
    .page-title .page-title-inner, .page-title .page-title-inner-additional, .page-title__additional, .page-title__plp {
      font-size: 36px
    }
  }

  @media (max-width: 767px) {
    .page-title .page-title-inner, .page-title .page-title-inner-additional, .page-title__additional, .page-title__plp {
      font-size: 18px
    }
  }

  .articles-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
  }

  .articles-content .article-link:nth-child(4), .articles-content .article-link:nth-child(6), .articles-content .article-link:nth-child(9) {
    margin-right: 0
  }

  .articles-content .article-link:first-child {
    height: 330px;
    width: 100%
  }

  .articles-content .article-link:first-child .article-preview {
    height: 100%
  }

  .articles-content .article-link:first-child .article-preview__img {
    position: absolute;
    height: 100%
  }

  .articles-content .article-link:first-child .article-preview__block {
    z-index: 10;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: max-content 24px;
    grid-template-areas: "title title title" "infoHow date social";
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0
  }

  @media (min-width: 768px) {
    .articles-content .article-link:first-child .article-preview__block .article-preview__info-date {
      margin: 0 25%
    }
  }

  .articles-content .article-link:first-child .article-preview__info-how {
    border-radius: 2px;
    border: 1px solid #fff;
    padding: 5px 14px;
    text-transform: uppercase;
    height: 24px;
    line-height: 1;
    color: #fff;
    text-align: center;
    width: -moz-max-content;
    width: max-content
  }

  .articles-content .article-link:first-child .article-preview__info-date {
    height: 24px;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }

  .articles-content .article-link:first-child .article-preview__title {
    font-size: 21px;
    color: #fff;
    line-height: 1.24;
    padding: 0;
    margin-bottom: 15px
  }

  .articles-content .article-link:first-child .article-preview__social {
    margin: 0;
    padding: 0;
    height: 24px
  }

  .articles-content .article-link:first-child .article-preview__discussion, .articles-content .article-link:first-child .article-preview__discussion i, .articles-content .article-link:first-child .article-preview__likes, .articles-content .article-link:first-child .article-preview__likes i, .articles-content .article-link:first-child .article-preview__views, .articles-content .article-link:first-child .article-preview__views i {
    color: #fff
  }

  .articles-content .article-link:first-child .article-preview__deck {
    display: none
  }

  .articles-content .article-link:first-child .article-preview__img-container {
    position: static
  }

  .articles-content .article-link:first-child .play-video-rectangle {
    height: 150px
  }

  @media (min-width: 768px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      height: 330px;
      width: 100%;
      width: 49%
    }

    .articles-content .article-link:nth-child(5) .article-preview, .articles-content .article-link:nth-child(6) .article-preview {
      height: 100%
    }

    .articles-content .article-link:nth-child(5) .article-preview__img, .articles-content .article-link:nth-child(6) .article-preview__img {
      position: absolute;
      height: 100%
    }

    .articles-content .article-link:nth-child(5) .article-preview__block, .articles-content .article-link:nth-child(6) .article-preview__block {
      z-index: 10;
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: -webkit-max-content 24px;
      grid-template-rows: max-content 24px;
      grid-template-areas: "title title title" "infoHow date social";
      height: auto;
      position: absolute;
      bottom: 0;
      left: 0
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-how, .articles-content .article-link:nth-child(6) .article-preview__info-how {
      border-radius: 2px;
      border: 1px solid #fff;
      padding: 5px 14px;
      text-transform: uppercase;
      height: 24px;
      line-height: 1;
      color: #fff;
      text-align: center;
      width: -moz-max-content;
      width: max-content
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__info-date {
      height: 24px;
      color: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center
    }

    .articles-content .article-link:nth-child(5) .article-preview__title, .articles-content .article-link:nth-child(6) .article-preview__title {
      font-size: 21px;
      color: #fff;
      line-height: 1.24;
      padding: 0;
      margin-bottom: 15px
    }

    .articles-content .article-link:nth-child(5) .article-preview__social, .articles-content .article-link:nth-child(6) .article-preview__social {
      margin: 0;
      padding: 0;
      height: 24px
    }

    .articles-content .article-link:nth-child(5) .article-preview__discussion, .articles-content .article-link:nth-child(5) .article-preview__discussion i, .articles-content .article-link:nth-child(5) .article-preview__likes, .articles-content .article-link:nth-child(5) .article-preview__likes i, .articles-content .article-link:nth-child(5) .article-preview__views, .articles-content .article-link:nth-child(5) .article-preview__views i, .articles-content .article-link:nth-child(6) .article-preview__discussion, .articles-content .article-link:nth-child(6) .article-preview__discussion i, .articles-content .article-link:nth-child(6) .article-preview__likes, .articles-content .article-link:nth-child(6) .article-preview__likes i, .articles-content .article-link:nth-child(6) .article-preview__views, .articles-content .article-link:nth-child(6) .article-preview__views i {
      color: #fff
    }

    .articles-content .article-link:nth-child(5) .article-preview__deck, .articles-content .article-link:nth-child(6) .article-preview__deck {
      display: none
    }

    .articles-content .article-link:nth-child(5) .article-preview__img-container, .articles-content .article-link:nth-child(6) .article-preview__img-container {
      position: static
    }

    .articles-content .article-link:nth-child(5) .play-video-rectangle, .articles-content .article-link:nth-child(6) .play-video-rectangle {
      height: 120px
    }
  }

  @media (min-width: 768px) and (min-width: 768px) {
    .articles-content .article-link:nth-child(5) .article-preview__block .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__block .article-preview__info-date {
      margin: 0 25%
    }
  }

  .articles-content .article-link:first-child {
    max-width: 100%;
    margin-right: 0
  }

  .articles-content .article-link:first-child .article-preview:before {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(73, 72, 72, 0)), color-stop(19%, rgba(73, 72, 72, 0.3)), to(#494848));
    background: linear-gradient(180deg, rgba(73, 72, 72, 0) 0%, rgba(73, 72, 72, 0.3) 19%, #494848);
    opacity: 0.6;
    z-index: 10
  }

  @media (max-width: 767px) {
    .articles-content .article-link:first-child .article-preview__block {
      grid-template-columns:auto auto auto;
      grid-template-rows: 24px max-content 24px;
      grid-template-areas: "infoHow infoHow infoHow" "title title title" "social social date"
    }

    .articles-content .article-link:first-child .article-preview__title {
      margin-top: 12px
    }

    .articles-content .article-link:first-child .article-preview__info-date {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end
    }
  }

  @media (min-width: 768px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      max-width: 436px
    }

    .articles-content .article-link:nth-child(5) .article-preview:before, .articles-content .article-link:nth-child(6) .article-preview:before {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: -webkit-gradient(linear, left top, left bottom, from(rgba(73, 72, 72, 0)), color-stop(19%, rgba(73, 72, 72, 0.3)), to(#494848));
      background: linear-gradient(180deg, rgba(73, 72, 72, 0) 0%, rgba(73, 72, 72, 0.3) 19%, #494848);
      opacity: 0.6;
      z-index: 10
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    .articles-content .article-link:nth-child(5) .article-preview__block, .articles-content .article-link:nth-child(6) .article-preview__block {
      grid-template-columns:auto auto auto;
      grid-template-rows: 24px max-content 24px;
      grid-template-areas: "infoHow infoHow infoHow" "title title title" "social social date"
    }

    .articles-content .article-link:nth-child(5) .article-preview__title, .articles-content .article-link:nth-child(6) .article-preview__title {
      margin-top: 12px
    }

    .articles-content .article-link:nth-child(5) .article-preview__info-date, .articles-content .article-link:nth-child(6) .article-preview__info-date {
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .articles-content .article-link:nth-child(5), .articles-content .article-link:nth-child(6) {
      max-width: 372px
    }
  }

  .list-paginator {
    font-weight: 600
  }

  .list-paginator .item-wrapper {
    display: inline-block
  }

  .list-paginator .paginator-item {
    color: #000;
    font-size: 16px;
    padding: 4px 5px;
    margin: 0 4px
  }

  .list-paginator .paginator-item:focus, .list-paginator .paginator-item:hover {
    text-decoration: none;
    color: #66c05d
  }

  .list-paginator .paginator-item.active {
    background-color: #66c05d;
    color: #fff
  }

  .list-paginator .delimiter:hover {
    color: #000
  }

  .list-paginator .items-wrapper, .list-paginator .next-paginator-button-wrapper, .list-paginator .prev-paginator-button-wrapper {
    display: inline-block;
    vertical-align: bottom
  }

  .list-paginator .paginator-button {
    background-color: transparent;
    width: 23px;
    height: 25px;
    display: block;
    position: relative;
    text-decoration: none
  }

  .list-paginator .paginator-button:after {
    top: 50%;
    width: 0;
    height: 0;
    margin-top: -5px;
    display: block;
    content: "";
    text-indent: -9999px;
    pointer-events: none;
    position: absolute;
    border: 5px solid rgba(102, 192, 93, 0);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease
  }

  .list-paginator .prev-paginator-button {
    border-right: 1px solid #e0e0e0
  }

  .list-paginator .prev-paginator-button:after {
    left: -2px;
    border-right-color: #66c05d
  }

  .list-paginator .next-paginator-button {
    border-left: 1px solid #e0e0e0
  }

  .list-paginator .next-paginator-button:after {
    left: 12px;
    border-left-color: #66c05d
  }

  .paginator-show-more {
    display: none;
    justify-content: center;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
  }

  .paginator-show-more {
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #66c05d;
  }

  @media (max-width: 767px) {
    .paginator-show-more {
      display: flex;
    }

    .pagination-page-numbers {
      display: none;
    }
  }

  .pull-right {
    float: right !important;
  }

  .category-description {
    width: 100%;
    padding: 30px;
    margin: 30px 0;
    background-color: #fff
  }

  .category-description .layout {
    height: auto
  }

  .category-description .layout .text {
    color: #666;
    font-size: 12px;
    line-height: 20px
  }

  .category-description .layout .text p {
    margin: 0 0 9px
  }

  .category-description .layout .text li {
    margin-bottom: 1px
  }

  .category-description .layout .text ol, .category-description .layout .text ul {
    margin-bottom: 12px
  }

  .category-description .layout .text ul {
    margin-left: 45px;
    padding: 0
  }

  .category-description .layout .text li, .category-description .layout .text ul {
    list-style-position: outside
  }

  .category-description .layout .text h1:first-child, .category-description .layout .text h2:first-child, .category-description .layout .text h3:first-child, .category-description .layout .text h4:first-child, .category-description .layout .text h5:first-child, .category-description .layout .text h6:first-child {
    margin-top: 0
  }

  .category-description .layout .text h1, .category-description .layout .text h2 {
    margin: 6px 0 8px;
    font-size: 16px;
    line-height: 21px;
  }

  .category-description .layout .text h3, .category-description .layout .text h4, .category-description .layout .text h5, .category-description .layout .text h6 {
    margin: 16px 0 8px;
    font-size: 14px;
    line-height: 20px
  }

  .category-description .layout .text a {
    text-decoration: underline;
    color: #66c05d
  }

  .category-description .layout .text a:hover {
    text-decoration: underline;
    color: #4ba842
  }
`;